// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Table,
//   Container,
//   Card,
//   Pagination,
//   Badge,
//   Modal,
//   Button,
//   InputGroup,
//   Form,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { BsEye } from "react-icons/bs";

// const ServitorConfirmOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterType, setFilterType] = useState("All");
//   const [filterStatus, setFilterStatus] = useState("All");

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const fetchOrders = async () => {
//     try {
//       const response = await axios.get(
//         "http://localhost:4001/accepted-servitor-orders"
//       );
//       setOrders(response.data);
//       setFilteredOrders(response.data); // Set initial filtered orders
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//     }
//   };

//   const handleViewDetails = (order) => {
//     setSelectedOrder(order);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedOrder(null);
//   };

//   // Search & Filter Logic
//   useEffect(() => {
//     let results = orders;

//     if (searchTerm) {
//       results = orders.filter(
//         (order) =>
//           order.User?.Id?.toString().includes(searchTerm) ||
//           order.User?.mobile?.toString().includes(searchTerm)
//       );
//     }

//     if (filterType !== "All") {
//       results = results.filter(
//         (order) => order.Service?.services_name === filterType
//       );
//     }

//     if (filterStatus !== "All") {
//       results = results.filter(
//         (order) =>
//           order.status &&
//           order.status.toLowerCase() === filterStatus.toLowerCase()
//       );
//     }

//     setFilteredOrders(results);
//     setCurrentPage(1);
//   }, [searchTerm, filterType, filterStatus, orders]);

//   // Pagination Logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Render Order Details (returns a list of order details)
//   const renderOrderDetails = () => {
//     if (!selectedOrder) return null;

//     let details = {};
//     // let type = "";
//     const type = selectedOrder.service_name;

//     // if (type === "Electrician") {
//     //   details = {
//     //     "Fan Installation Units": selectedOrder.Fan_in_un,
//     //     "Light Installation Units": selectedOrder.Light_in_un,
//     //     "Fan Repair": selectedOrder.Fan_repair,
//     //     "Light Repair": selectedOrder.Light_repair,
//     //     "Switch Board Repair": selectedOrder.Switch_repair,
//     //     "MCB Servicing": selectedOrder.MCB_service,
//     //     "MDB Servicing": selectedOrder.MDB_service,
//     //   };
//     // } else if ('bed' in selectedOrder) {
//     //   type = "Home Cleaning";
//     //   details = {
//     //     "Bed Cleaning": selectedOrder.bed,
//     //     "Bathroom Cleaning": selectedOrder.bath,
//     //     "Drawing/Dining Cleaning": selectedOrder.dra_din,
//     //     "Kitchen Cleaning": selectedOrder.kitchen,
//     //     "Cloth Washing": selectedOrder.cloth,
//     //     "Dish Washing": selectedOrder.dish,
//     //   };
//     // } else {
//     //   type = "Plumber";
//     //   details = {
//     //     "Toilet Installation": selectedOrder.Toilet_in,
//     //     "Faucet Installation": selectedOrder.Faucet_in,
//     //     "Sink Installation": selectedOrder.Sink_in,
//     //     "Dishwasher Installation": selectedOrder.Dishwasher_in,
//     //     "Leak Repair": selectedOrder.Leak_repair,
//     //     "Faucet Repair": selectedOrder.Faucet_repair,
//     //     "Toilet Repair": selectedOrder.Toilet_repair,
//     //     "Shower Repair": selectedOrder.Shower_repair,
//     //     "Drain Cleaning": selectedOrder.Drain_cleaning,
//     //   };
//     // }

//     if (type === "Electrician") {
//       details = {
//         "Fan Installation Units": selectedOrder.Fan_in_un,
//         "Light Installation Units": selectedOrder.Light_in_un,
//         "Fan Repair": selectedOrder.Fan_repair,
//         "Light Repair": selectedOrder.Light_repair,
//         "Switch Board Repair": selectedOrder.Switch_repair,
//         "MCB Servicing": selectedOrder.MCB_service,
//         "MDB Servicing": selectedOrder.MDB_service,
//         "Regulator Install/Uninstall": selectedOrder.Fan_regulator_in_un,
//         "Regulator Repair": selectedOrder.Fan_regulator_repair,
//         "Socket Install/Uninstall": selectedOrder.Socket_in_un,
//         "Socket Repair": selectedOrder.Socket_repair,
//         "Circuit Breaker Repair": selectedOrder.Circuit_breaker_repair,
//         "New Wiring Point": selectedOrder.New_wiring_point,
//         "Full Wiring": selectedOrder.Full_wiring ? "Yes" : "No",
//         "Electrical Checkup": selectedOrder.Electrical_checkup ? "Yes" : "No",
//       };
//     } else if (type === "Home Cleaning") {
//       details = {
//         "Bed Cleaning": selectedOrder.bed,
//         "Bathroom Cleaning": selectedOrder.bath,
//         "Drawing/Dining Cleaning": selectedOrder.dra_din,
//         "Kitchen Cleaning": selectedOrder.kitchen,
//         "Balcony Cleaning": selectedOrder.balcony,
//         "Window & Grill Cleaning": selectedOrder.window_grill,
//         "Furniture Cleaning": selectedOrder.furniture_cleaning,
//         "Cloth Washing": selectedOrder.cloth,
//         "Dish Washing": selectedOrder.dish,
//       };
//     } else if (type === "Plumber") {
//       details = {
//         "Toilet Installation": selectedOrder.Toilet_in,
//         "Faucet Installation": selectedOrder.Faucet_in,
//         "Sink Installation": selectedOrder.Sink_in,
//         "Dishwasher Installation": selectedOrder.Dishwasher_in,
//         "Leak Repair": selectedOrder.Leak_repair,
//         "Faucet Repair": selectedOrder.Faucet_repair,
//         "Toilet Repair": selectedOrder.Toilet_repair,
//         "Shower Repair": selectedOrder.Shower_repair,
//         "Drain Cleaning": selectedOrder.Drain_cleaning,
//         "Pipe Cleaning": selectedOrder.pipe_cleaning,
//         "Tank Cleaning": selectedOrder.tank_cleaning,
//         "Issue Checkup": selectedOrder.issue_checkup ? "Yes" : "No",
//       };
//     }

//     return (
//       <div>
//         <h5 className="text-primary">{type} Order Details</h5>
//         <ul className="list-group">
//           {Object.entries(details).map(([key, value]) => (
//             <li
//               key={key}
//               className="list-group-item d-flex justify-content-between"
//             >
//               <span>{key}</span>
//               <strong>{value}</strong>
//             </li>
//           ))}
//         </ul>
//       </div>
//     );
//   };

//   // Render Servitor Details (returns a list of servitor details)
//   const renderServitorDetails = () => {
//     if (!selectedOrder || !selectedOrder.Servitor) return null;

//     return (
//       <div>
//         <h5 className="text-primary">Servitor Details</h5>
//         <ul className="list-group">
//           <li className="list-group-item d-flex justify-content-between">
//             <span>Name:</span>
//             <strong>
//               {selectedOrder.Servitor.FirstName}{" "}
//               {selectedOrder.Servitor.LastName}
//             </strong>
//           </li>
//           <li className="list-group-item d-flex justify-content-between">
//             <span>Email:</span>
//             <strong>{selectedOrder.Servitor.email}</strong>
//           </li>
//           <li className="list-group-item d-flex justify-content-between">
//             <span>Phone:</span>
//             <strong>{selectedOrder.Servitor.mobile}</strong>
//           </li>
//           <li className="list-group-item d-flex justify-content-between">
//             <span>NID:</span>
//             <strong>{selectedOrder.Servitor.NID}</strong>
//           </li>
//           <li className="list-group-item d-flex justify-content-between">
//             <span>Address:</span>
//             <strong>
//               {selectedOrder.Servitor.Address}, {selectedOrder.Servitor.city}
//             </strong>
//           </li>
//         </ul>
//       </div>
//     );
//   };

//   return (
//     <Container fluid>
//       <Card>
//         <Card.Body>
//           <Card.Title
//             className="mb-3"
//             style={{ fontSize: "26px", fontWeight: "400" }}
//           >
//             Servitor Accepted Orders
//           </Card.Title>

//           {/* Search Bar */}
//           {/* <InputGroup className="mb-3">
//             <Form.Control
//               type="text"
//               placeholder="Search by User ID or Mobile Number"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </InputGroup> */}
//           <Row className="mb-3">
//             {/* Search Bar */}
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by User ID or Mobile Number"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//               </InputGroup>
//             </Col>
//             {/* Status filter */}
//             <Col md={4}>
//               <Form.Group controlId="statusFilter">
//                 <Form.Select
//                   value={filterStatus}
//                   onChange={(e) => setFilterStatus(e.target.value)}
//                 >
//                   <option value="All">All Statuses</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="In-Progress">In-Progress</option>
//                   <option value="Completed">Completed</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* Filter Buttons */}
//           <div className="mb-3">
//             {["All", "Electrician", "Home Cleaning", "Plumber"].map((type) => (
//               <Button
//                 key={type}
//                 variant={filterType === type ? "primary" : "outline-primary"}
//                 className="me-2 mb-2"
//                 onClick={() => setFilterType(type)}
//               >
//                 {type}
//               </Button>
//             ))}
//           </div>

//           <Table striped bordered hover responsive>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Order number</th>
//                 <th>User ID</th>
//                 <th>User</th>
//                 <th>Mobile</th>
//                 <th>Service</th>
//                 <th>Servitor</th>
//                 <th>Status</th>
//                 <th>Price</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.map((order, index) => (
//                 <tr key={order.Id}>
//                   <td>{index + 1 + indexOfFirstItem}</td>
//                   <td>{order.order_number}</td>
//                   <td>{order.User?.Id}</td>
//                   <td>
//                     {order.User?.FirstName} {order.User?.LastName}
//                   </td>
//                   <td>{order.User?.mobile}</td>
//                   <td>{order.Service?.services_name}</td>
//                   <td>
//                     {order.Servitor?.FirstName} {order.Servitor?.LastName}
//                   </td>
//                   {/* <td>
//                     <Badge bg="success">{order.status}</Badge>
//                   </td> */}
//                   <td>
//                     {order.status === "Accepted" ? (
//                       <Badge bg="primary">{order.status}</Badge>
//                     ) : order.status === "In-Progress" ? (
//                       <Badge bg="warning">{order.status}</Badge>
//                     ) : order.status === "Completed" ? (
//                       <Badge bg="success">{order.status}</Badge>
//                     ) : (
//                       <Badge bg="info">{order.status}</Badge>
//                     )
//                     }
//                   </td>
//                   <td>{order.price}Tk</td>
//                   <td>{order.date}</td>
//                   <td>{order.time}</td>
//                   <td>
//                     <Button
//                       variant="outline-primary"
//                       size="sm"
//                       onClick={() => handleViewDetails(order)}
//                     >
//                       <BsEye size={20} />
//                     </Button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>

//           {/* Pagination */}
//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {/* Modal for Viewing Servitor & Order Details Side by Side */}
//       <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Servitor & Order Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Row>
//             <Col md={6}>{renderServitorDetails()}</Col>
//             <Col md={6}>{renderOrderDetails()}</Col>
//           </Row>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseModal}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// };

// export default ServitorConfirmOrders;

// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import {
//   Table,
//   Container,
//   Card,
//   Pagination,
//   Badge,
//   Button,
//   InputGroup,
//   Form,
//   Row,
//   Col,
// } from "react-bootstrap";

// import { BsEye } from "react-icons/bs";

// import {
//   FaTimes,
//   FaBolt,
//   FaUser,
//   FaCheckCircle,
//   FaDollarSign,
//   FaCalendar,
//   FaPlusCircle,
//   FaWrench,
//   FaCogs,
//   FaStar,
//   FaUserCircle,
//   FaPhone,
//   FaIdBadge,
//   FaMapMarkerAlt,
//   FaClock,
//   FaPrint,
//   FaDownload,
//   FaCheck,
//   FaEdit,
//   FaTrash,
//   FaBroom,
//   FaFire,
//   FaSnowflake,
//   FaFilter,
//   FaUserGraduate,
// } from "react-icons/fa";
// import "./ServitorConfirmOrders.css";
// import { formatDate } from "../../dateTimefrontpart";
// import { URL } from "../../../config";

// const ServitorConfirmOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterType, setFilterType] = useState("All");
//   const [filterStatus, setFilterStatus] = useState("All");
//   const modalRef = useRef(null);
//   const itemsPerPage = 10;

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const fetchOrders = async () => {
//     try {
//       const response = await axios.get(
//         `${URL}/accepted-servitor-orders`
//       );
//       setOrders(response.data);
//       setFilteredOrders(response.data);
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//     }
//   };

//   const handleViewDetails = (order) => {
//     setSelectedOrder(order);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedOrder(null);
//     document.body.style.overflow = "auto";
//   };

//   const handleEditOrder = (order) => {
//     console.log("Editing order:", order);
//     // Implement edit functionality here
//   };

//   const handleDeleteOrder = (order) => {
//     console.log("Deleting order:", order);
//     // Implement delete functionality here
//   };

//   useEffect(() => {
//     const node = modalRef.current;
//     const handleBackdropClick = (e) => {
//       if (node && e.target === node) {
//         handleCloseModal();
//       }
//     };

//     const handleEscapeKey = (e) => {
//       if (e.key === "Escape") {
//         handleCloseModal();
//       }
//     };

//     if (node) {
//       node.addEventListener("click", handleBackdropClick);
//     }
//     document.addEventListener("keydown", handleEscapeKey);

//     return () => {
//       if (node) {
//         node.removeEventListener("click", handleBackdropClick);
//       }
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   useEffect(() => {
//     let results = orders;

//     // if (searchTerm) {
//     //   results = results.filter(
//     //     (order) =>
//     //       order.User?.Id?.toString().includes(searchTerm) ||
//     //       order.User?.mobile?.toString().includes(searchTerm)
//     //   );
//     // }

//     if (searchTerm) {
//       const term = searchTerm.toLowerCase();
//       results = results.filter(
//         (order) =>
//           order.User?.Id?.toString().includes(term) ||
//           order.User?.mobile?.toString().includes(term) ||
//           order.order_number?.toLowerCase().includes(term)
//       );
//     }

//     if (filterType !== "All") {
//       results = results.filter(
//         (order) => order.Service?.services_name === filterType
//       );
//     }

//     if (filterStatus !== "All") {
//       results = results.filter(
//         (order) =>
//           order.status &&
//           order.status.toLowerCase() === filterStatus.toLowerCase()
//       );
//     }

//     setFilteredOrders(results);
//     setCurrentPage(1);
//   }, [searchTerm, filterType, filterStatus, orders]);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handlePrintReceipt = () => {
//     console.log("Printing order receipt...");
//   };

//   const handleDownloadInvoice = () => {
//     console.log("Downloading invoice...");
//   };

//   const buildTimeline = (order) => {
//     const steps = [];
//     steps.push({
//       key: "placed",
//       label: "Order Placed",
//       time: order.created_at,
//       dotClass: "completed",
//     });

//     if (order.accepted_at) {
//       steps.push({
//         key: "accepted",
//         label: "Order Accepted",
//         time: order.accepted_at,
//         dotClass:
//           order.status === "Accepted" ||
//           order.status === "In-Progress" ||
//           order.status === "Completed"
//             ? "completed"
//             : "inactive",
//       });
//     }

//     if (order.in_progress_at) {
//       steps.push({
//         key: "in_progress",
//         label: "Service In Progress",
//         time: order.in_progress_at,
//         dotClass:
//           order.status === "In-Progress" || order.status === "Completed"
//             ? "in-progress"
//             : "inactive",
//       });
//     }

//     if (order.completed_at) {
//       steps.push({
//         key: "completed",
//         label: "Order Completed",
//         time: order.completed_at,
//         dotClass: "arrived",
//       });
//     }

//     if (order.status.toLowerCase().includes("cancel")) {
//       steps.push({
//         key: "cancelled",
//         label: `Order ${order.status}`,
//         time: order.updated_at,
//         dotClass: "cancelled",
//       });
//     }

//     return steps;
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) {
//       end = Math.min(total - 1, maxButtons - 1);
//     }
//     if (current >= total - (siblings + 1)) {
//       start = Math.max(2, total - (maxButtons - 2));
//     }

//     if (start > 2) {
//       pages.push("start-ellipsis");
//     }

//     for (let i = start; i <= end; i++) {
//       pages.push(i);
//     }

//     if (end < total - 1) {
//       pages.push("end-ellipsis");
//     }

//     if (total > 1) {
//       pages.push(total);
//     }

//     return pages;
//   };

//   const renderOrderDetails = () => {
//     if (!selectedOrder) return null;

//     let details = {};
//     const type = selectedOrder.service_name;
//     let icon = <FaBolt style={{ color: "#10b981" }} />;

//     if (type === "Electrician") {
//       details = {
//         Installation: {
//           "Fan Installation Units": selectedOrder.Fan_in_un,
//           "Light Installation Units": selectedOrder.Light_in_un,
//           "Doorbell Setup Units": selectedOrder.Doorbell_setup,
//           "Exhaust Fan Setup Units": selectedOrder.Exhaust_fan_setup,
//           "Regulator Install/Uninstall": selectedOrder.Fan_regulator_in_un,
//           "Socket Install/Uninstall": selectedOrder.Socket_in_un,
//         },
//         Repair: {
//           "Fan Repair": selectedOrder.Fan_repair,
//           "Light Repair": selectedOrder.Light_repair,
//           "Exhaust Fan Repair": selectedOrder.Exhaust_fan_repair,
//           "Switch Board Repair": selectedOrder.Switch_repair,
//           "Socket Repair": selectedOrder.Socket_repair,
//           "Circuit Breaker Repair": selectedOrder.Circuit_breaker_repair,
//         },
//         Maintenance: {
//           "MCB Servicing": selectedOrder.MCB_service,
//           "MDB Servicing": selectedOrder.MDB_service,
//         },
//         Additional: {
//           "New Wiring Point": selectedOrder.New_wiring_point,
//           "Drill Wall holes": selectedOrder.Drill_wall_holes,
//           "Coil Repair": selectedOrder.Coil_repair,
//           // "Full Wiring": selectedOrder.Full_wiring ? "Yes" : "No",
//           "Electrical Checkup": selectedOrder.Electrical_checkup ? "Yes" : "No",
//         },
//       };
//       // icon = <FaBolt style={{ color: "#10b981" }} />;
//       icon = <FaBolt />;
//     } else if (type === "Home Cleaning") {
//       details = {
//         "Room Cleaning": {
//           "Bed Cleaning": selectedOrder.bed,
//           "Bathroom Cleaning": selectedOrder.bath,
//           "Drawing/Dining Cleaning": selectedOrder.dra_din,
//           "Balcony Cleaning": selectedOrder.balcony,
//           "Kitchen Cleaning": selectedOrder.kitchen,
//           "Satirs & Railing Cleaning": selectedOrder.stairs_and_railing,
//         },
//         "Additional Cleaning": {
//           "Window & Grill Cleaning": selectedOrder.window_grill,
//           "Furniture Cleaning": selectedOrder.furniture_cleaning,
//           "Cloth Washing": selectedOrder.cloth,
//           "Dish Washing": selectedOrder.dish,
//           "Carpet Cleaning": selectedOrder.carpet_cleaning,
//         },
//       };
//       icon = <FaBroom />;
//     } else if (type === "Plumber") {
//       details = {
//         Installation: {
//           "Toilet Installation": selectedOrder.Toilet_in,
//           "Faucet Installation": selectedOrder.Faucet_in,
//           "Sink Installation": selectedOrder.Sink_in,
//           "Dishwasher Installation": selectedOrder.Dishwasher_in,
//           "Geyser Installation": selectedOrder.geyser_setup,
//         },
//         Repair: {
//           "Leak Repair": selectedOrder.Leak_repair,
//           "Faucet Repair": selectedOrder.Faucet_repair,
//           "Toilet Repair": selectedOrder.Toilet_repair,
//           "Shower Repair": selectedOrder.Shower_repair,
//           "Geyser Repair": selectedOrder.geyser_repair,
//         },
//         Maintenance: {
//           "Drain Cleaning": selectedOrder.Drain_cleaning,
//           "Pipe Cleaning": selectedOrder.pipe_cleaning,
//           "Tank Cleaning": selectedOrder.tank_cleaning,
//           "Issue Checkup": selectedOrder.issue_checkup ? "Yes" : "No",
//         },
//       };
//       icon = <FaCogs />;
//     } else if (type === "Gas Chula") {
//       details = {
//         Installation: {
//           "Cylinder Type": selectedOrder.chulaCylinderType,
//           "New Chula Setup": selectedOrder.NewchulaSetup,
//           "Chula Setup": selectedOrder.chulaSetup,
//           "Burner Setup": selectedOrder.burnerSetup,
//         },
//         Maintenance: {
//           "Burner Cleaning": selectedOrder.burnerCleaning,
//           "Nozzle Replacement": selectedOrder.nozzleReplacement,
//           "Check Issues": selectedOrder.checkIssues ? "Yes" : "No",
//         },
//       };
//       icon = <FaFire />;
//     } else if (type === "AC Service") {
//       details = {
//         Specifications: {
//           "AC Type": selectedOrder.acType || "-",
//           "AC Ton": selectedOrder.acTon || "-",
//         },
//         Installation: {
//           "New Setup": selectedOrder.new_setup, // or selectedOrder.newSetup
//           Installation: selectedOrder.installation,
//           Uninstallation: selectedOrder.uninstallation,
//         },
//         Maintenance: {
//           "Gas Refill": selectedOrder.gas_refill, // or selectedOrder.gasRefill
//           Cleaning: selectedOrder.cleaning,
//           "Issue Checkup": selectedOrder.issue_checkup ? "Yes" : "No", // or selectedOrder.issueCheckup
//         },
//       };
//       icon = <FaSnowflake />;
//     } else if (type === "Filter") {
//       details = {
//         Specifications: {
//           "Filter Type": selectedOrder.filter_type || "-",
//         },
//         Additional: {
//           "Issue Checkup": selectedOrder.check_up ? "Yes" : "No",
//         },
//         Installation: {
//           "New Filter Setup": selectedOrder.new_filter_setup,
//           "Filter Installation": selectedOrder.installation_filter,
//           "Filter Uninstallation": selectedOrder.uninstallation_filter,
//         },
//         Maintenance: {
//           "Kit Replacement": selectedOrder.kit_replacement,
//           "Pipe Leak / Replace": selectedOrder.pipe_leak_or_replace,
//           "Full Servicing": selectedOrder.full_servicing,
//         },
//       };
//       icon = <FaFilter />;
//     } else if (type === "Tutor Service") {
//       const clean = (v) =>
//         v !== undefined &&
//         v !== null &&
//         String(v).trim() !== "" &&
//         String(v).trim().toLowerCase() !== "any";

//       const core = {};
//       if (clean(selectedOrder.subject)) core["Subject"] = selectedOrder.subject;
//       if (clean(selectedOrder.classLevel))
//         core["Class/Level"] = selectedOrder.classLevel;
//       if (clean(selectedOrder.medium)) core["Medium"] = selectedOrder.medium;

//       const schedule = {};
//       if (clean(selectedOrder.daysPerWeek))
//         schedule["Days per Week"] = `${selectedOrder.daysPerWeek}`;
//       if (clean(selectedOrder.hoursPerDay))
//         schedule["Hours per Day"] = `${selectedOrder.hoursPerDay}`;
//       if (clean(selectedOrder.salary))
//         schedule["Salary"] = `৳${selectedOrder.salary}`;

//       const prefs = {};
//       if (clean(selectedOrder.preferredTutorGender))
//         prefs["Preferred Tutor Gender"] = selectedOrder.preferredTutorGender;
//       if (clean(selectedOrder.priorityInstitution))
//         prefs["Priority Institution"] = selectedOrder.priorityInstitution;

//       details = {};
//       if (Object.keys(core).length) details["Tutoring"] = core;
//       if (Object.keys(schedule).length) details["Schedule & Budget"] = schedule;
//       if (Object.keys(prefs).length) details["Preferences"] = prefs;

//       icon = <FaUserGraduate />;
//     }

//     return (
//       <div className="adminServitorOrders-modal">
//         <div className="adminServitorOrders-modal-header">
//           <button
//             className="adminServitorOrders-modal-close"
//             onClick={handleCloseModal}
//           >
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminServitorOrders-service-icon">{icon}</div>
//             <div>
//               <h2 className="adminServitorOrders-modal-title">Order Details</h2>
//               <p className="adminServitorOrders-modal-subtitle">
//                 Order #{selectedOrder.order_number} • {type} Service
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="adminServitorOrders-modal-body">
//           <div className="adminServitorOrders-summary-cards">
//             <div className="adminServitorOrders-summary-card adminServitorOrders-status-card">
//               <div>
//                 <p className="adminServitorOrders-detail-text">Status</p>
//                 <span
//                   className={`adminServitorOrders-badge-${selectedOrder.status
//                     .toLowerCase()
//                     .replace(" ", "-")}`}
//                 >
//                   {selectedOrder.status}
//                 </span>
//               </div>
//               <FaCheckCircle size={24} style={{ color: "#22c55e" }} />
//             </div>
//             <div className="adminServitorOrders-summary-card adminServitorOrders-price-card">
//               <div>
//                 <p className="adminServitorOrders-detail-text">Total Amount</p>
//                 <p className="adminServitorOrders-price-value">
//                   ৳{selectedOrder.price}
//                 </p>
//               </div>
//               <FaDollarSign size={24} style={{ color: "#2563eb" }} />
//             </div>
//             <div className="adminServitorOrders-summary-card adminServitorOrders-date-card">
//               <div>
//                 <p className="adminServitorOrders-detail-text">Service Date</p>
//                 <p className="adminServitorOrders-date-value">
//                   {formatDate(selectedOrder.date)}
//                 </p>
//                 <p className="adminServitorOrders-time-value">
//                   {selectedOrder.time}
//                 </p>
//               </div>
//               <FaCalendar size={24} style={{ color: "#7c3aed" }} />
//             </div>
//           </div>

//           <div className="adminServitorOrders-detail-card">
//             <h3 className="adminServitorOrders-detail-title">
//               <FaUser style={{ marginRight: "8px", color: "#10b981" }} />
//               Customer Information
//             </h3>
//             <div className="adminServitorOrders-customer-grid">
//               <div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaUserCircle className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Customer Name
//                     </p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.User?.FirstName}{" "}
//                       {selectedOrder.User?.LastName}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaPhone className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Mobile Number
//                     </p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.User?.mobile}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaIdBadge className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">User ID</p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.User?.Id}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaMapMarkerAlt className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Service Location
//                     </p>
//                     {/* <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.User?.city}, {selectedOrder.User?.Address}
//                     </p> */}

//                     <p className="adminServitorOrders-detail-value">
//                       {/* This is for user location what set in profile */}
//                       {/* {[selectedOrder.User?.city, selectedOrder.User?.area, selectedOrder.User?.Address]
//                         .filter(Boolean)
//                         .join("- ")} */}

//                       {/* This is for Service location where user placed order */}
//                       {[selectedOrder.City, selectedOrder.Area, selectedOrder.Address]
//                         .filter(Boolean)
//                         .join(" - ")
//                       }
//                     </p>

//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="adminServitorOrders-detail-card">
//             <h3 className="adminServitorOrders-detail-title">
//               <FaUser style={{ marginRight: "8px", color: "#10b981" }} />
//               Servitor Information
//             </h3>
//             <div className="adminServitorOrders-customer-grid">
//               <div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaUserCircle className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Servitor Name
//                     </p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.Servitor?.FirstName}{" "}
//                       {selectedOrder.Servitor?.LastName}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaPhone className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Mobile Number
//                     </p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.Servitor?.mobile}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaIdBadge className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">NID</p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.Servitor?.NID}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaMapMarkerAlt className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">Address</p>
//                     {/* <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.Servitor?.city},{" "}
//                       {selectedOrder.Servitor?.Address}
//                     </p> */}

//                     <p className="adminServitorOrders-detail-value">
//                       {[selectedOrder.Servitor?.city, selectedOrder.Servitor?.area, selectedOrder.Servitor?.Address]
//                         .filter(Boolean)
//                         .join(" - ")}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="adminServitorOrders-detail-card">
//             <h3 className="adminServitorOrders-detail-title">
//               {/* {icon} {type} Service Details */}
//               {type} Service Details
//             </h3>
//             <div className="adminServitorOrders-service-grid">
//               {Object.entries(details).map(([category, items]) => (
//                 <div
//                   key={category}
//                   className="adminServitorOrders-service-category"
//                 >
//                   <h4 className="adminServitorOrders-category-title">
//                     {category === "Installation" && (
//                       <FaPlusCircle
//                         style={{ marginRight: "8px", color: "#22c55e" }}
//                       />
//                     )}
//                     {category === "Repair" && (
//                       <FaWrench
//                         style={{ marginRight: "8px", color: "#f59e0b" }}
//                       />
//                     )}
//                     {category === "Maintenance" && (
//                       <FaCogs
//                         style={{ marginRight: "8px", color: "#3b82f6" }}
//                       />
//                     )}
//                     {category === "Additional" && (
//                       <FaStar
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Room Cleaning" && (
//                       <FaBroom
//                         style={{ marginRight: "8px", color: "#10b981" }}
//                       />
//                     )}
//                     {category === "Additional Cleaning" && (
//                       <FaStar
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Specifications" && (
//                       <FaSnowflake
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}

//                     {category === "Tutoring" && (
//                       <FaUserGraduate
//                         style={{ marginRight: "8px", color: "#2563eb" }}
//                       />
//                     )}
//                     {category === "Schedule & Budget" && (
//                       <FaCalendar
//                         style={{ marginRight: "8px", color: "#7c3aed" }}
//                       />
//                     )}
//                     {category === "Preferences" && (
//                       <FaStar
//                         style={{ marginRight: "8px", color: "#f59e0b" }}
//                       />
//                     )}
//                     {category}
//                   </h4>
//                   <div
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "8px",
//                     }}
//                   >
//                     {Object.entries(items).map(([key, value]) => (
//                       <div
//                         key={key}
//                         className={`adminServitorOrders-service-item ${
//                           value === "No" || value === 0 ? "inactive" : ""
//                         }`}
//                       >
//                         <span
//                           className={`adminServitorOrders-service-name ${
//                             value === "No" || value === 0 ? "inactive" : ""
//                           }`}
//                         >
//                           {key}
//                         </span>
//                         <span
//                           className={`adminServitorOrders-service-value${
//                             value === "No" || value === 0 ? "-inactive" : ""
//                           }`}
//                         >
//                           {value}
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="adminServitorOrders-detail-card">
//             <h3 className="adminServitorOrders-detail-title">
//               <FaClock style={{ marginRight: "8px", color: "#10b981" }} />
//               Order Timeline
//             </h3>
//             <div
//               style={{ display: "flex", flexDirection: "column", gap: "16px" }}
//             >
//               {buildTimeline(selectedOrder).map((step) => (
//                 <div
//                   key={step.key}
//                   className="adminServitorOrders-timeline-item"
//                 >
//                   {step.key === "cancelled" ? (
//                     <FaTimes
//                       size={16}
//                       className="adminServitorOrders-timeline-cancel-icon"
//                     />
//                   ) : (
//                     <div
//                       className={`adminServitorOrders-timeline-dot ${step.dotClass}`}
//                     ></div>
//                   )}
//                   <div className="adminServitorOrders-timeline-content">
//                     <h4>{step.label}</h4>
//                     <p>{new Date(step.time).toLocaleString()}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {selectedOrder.status.toLowerCase() === "cancelled" &&
//             selectedOrder.cancellation_feedback && (
//               <div className="adminServitorOrders-detail-card">
//                 <h3 className="adminServitorOrders-detail-title">
//                   <FaTimes style={{ marginRight: "8px", color: "#ef4444" }} />
//                   Cancellation Details
//                 </h3>
//                 <p className="adminServitorOrders-detail-value">
//                   {selectedOrder.cancellation_feedback}
//                 </p>
//               </div>
//             )}
//         </div>

//         <div className="adminServitorOrders-modal-footer">
//           <div className="adminServitorOrders-footer-buttons">
//             <button
//               className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-print"
//               onClick={handlePrintReceipt}
//             >
//               <FaPrint />
//               Print Receipt
//             </button>
//             <button
//               className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-download"
//               onClick={handleDownloadInvoice}
//             >
//               <FaDownload />
//               Download Invoice
//             </button>
//             <button
//               className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaCheck />
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Container fluid className="adminServitorOrders-container">
//       <Card className="adminServitorOrders-card">
//         <Card.Body>
//           {/* <Card.Title className="adminServitorOrders-title">
//             Servitor Accepted Orders
//           </Card.Title> */}

//           <Card.Header className="adminServitorOrders-header">
//             <h4 className="adminServitorOrders-title">
//               Servitor Accepted Orders
//             </h4>
//           </Card.Header>

//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Order Number, User ID or Mobile Number"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="adminServitorOrders-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="statusFilter">
//                 <Form.Select
//                   value={filterStatus}
//                   onChange={(e) => setFilterStatus(e.target.value)}
//                   className="adminServitorOrders-filter-select"
//                 >
//                   <option value="All">All Statuses</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="In-Progress">In-Progress</option>
//                   <option value="Completed">Completed</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="adminServitorOrders-filter-container">
//             {[
//               "All",
//               "Electrician",
//               "Home Cleaning",
//               "Plumber",
//               "Gas Chula",
//               "AC Service",
//               "Filter",
//               "Tutor Service",
//             ].map((type) => (
//               <Button
//                 key={type}
//                 variant={filterType === type ? "primary" : "outline-primary"}
//                 className="adminServitorOrders-filter-btn"
//                 onClick={() => setFilterType(type)}
//               >
//                 {type}
//               </Button>
//             ))}
//           </div>

//           <Table
//             striped
//             bordered
//             hover
//             responsive
//             className="adminServitorOrders-table"
//           >
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Order number</th>
//                 <th>User ID</th>
//                 {/* <th>User</th> */}
//                 <th>Mobile</th>
//                 <th>Service</th>
//                 <th>Servitor ID</th>
//                 <th>Status</th>
//                 <th>Price</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.map((order, index) => (
//                 <tr key={order.Id}>
//                   <td>{index + 1 + indexOfFirstItem}</td>
//                   <td>{order.order_number}</td>
//                   <td>{order.User?.Id}</td>
//                   {/* <td>
//                     {order.User?.FirstName} {order.User?.LastName}
//                   </td> */}
//                   <td>{order.User?.mobile}</td>
//                   <td>{order.Service?.services_name}</td>
//                   <td>
//                     {/* {order.Servitor?.FirstName} {order.Servitor?.LastName} */}
//                     {order.Servitor?.Id}
//                   </td>
//                   <td>
//                     <Badge
//                       className={`adminServitorOrders-badge-${order.status
//                         .toLowerCase()
//                         .replace(" ", "-")}`}
//                     >
//                       {order.status}
//                     </Badge>
//                   </td>
//                   <td>{order.price}Tk</td>
//                   {/* <td>{order.date}</td> */}
//                   <td>{formatDate(order.date)}</td>
//                   <td>{order.time}</td>
//                   <td>
//                     <div className="adminServitorOrders-action-group">
//                       <Button
//                         variant="outline-primary"
//                         size="sm"
//                         className="adminServitorOrders-action-btn"
//                         onClick={() => handleViewDetails(order)}
//                       >
//                         <BsEye size={16} />
//                       </Button>
//                       <Button
//                         variant="outline-edit"
//                         size="sm"
//                         className="adminServitorOrders-action-btn"
//                         onClick={() => handleEditOrder(order)}
//                       >
//                         <FaEdit size={16} />
//                       </Button>
//                       <Button
//                         variant="outline-danger"
//                         size="sm"
//                         className="adminServitorOrders-action-btn"
//                         onClick={() => handleDeleteOrder(order)}
//                       >
//                         <FaTrash size={16} />
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>

//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {getPageItems(totalPages, currentPage).map((item, idx) => {
//               if (item === "start-ellipsis" || item === "end-ellipsis") {
//                 return <Pagination.Ellipsis key={item + idx} disabled />;
//               }
//               return (
//                 <Pagination.Item
//                   key={item}
//                   active={item === currentPage}
//                   onClick={() => handlePageChange(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               );
//             })}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div className="adminServitorOrders-modal-backdrop" ref={modalRef}>
//           {renderOrderDetails()}
//         </div>
//       )}
//     </Container>
//   );
// };

// export default ServitorConfirmOrders;












// ***** Update with pagination and search, filter (19-Oct-2025) ***** //
// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import {
//   Table,
//   Container,
//   Card,
//   Pagination,
//   Badge,
//   Button,
//   InputGroup,
//   Form,
//   Row,
//   Col,
// } from "react-bootstrap";

// import { BsEye } from "react-icons/bs";

// import {
//   FaTimes,
//   FaBolt,
//   FaUser,
//   FaCheckCircle,
//   FaDollarSign,
//   FaCalendar,
//   FaPlusCircle,
//   FaWrench,
//   FaCogs,
//   FaStar,
//   FaUserCircle,
//   FaPhone,
//   FaIdBadge,
//   FaMapMarkerAlt,
//   FaClock,
//   FaPrint,
//   FaDownload,
//   FaCheck,
//   FaEdit,
//   FaTrash,
//   FaBroom,
//   FaFire,
//   FaSnowflake,
//   FaFilter as FaFilterIcon,
//   FaUserGraduate,
// } from "react-icons/fa";
// import "./ServitorConfirmOrders.css";
// import { formatDate } from "../../dateTimefrontpart";
// import { URL } from "../../../config";

// const DEFAULT_LIMIT = 10;

// const normalizeStatusKey = (s) =>
//   (s ? String(s).toLowerCase().replace(/\s+/g, "-") : "unknown");

// const getServiceName = (row) =>
//   row?.Service?.services_name ||
//   row?.service_name ||
//   row?.service ||
//   row?.serviceType ||
//   "Service";

// const toBoolYesNo = (v) => (v ? "Yes" : "No");
// const safeNum = (v, fallback = 0) => (v === 0 || v ? v : fallback);

// const ServitorConfirmOrders = () => {
//   // data
//   const [orders, setOrders] = useState([]);
//   const [meta, setMeta] = useState({
//     page: 1,
//     limit: DEFAULT_LIMIT,
//     total: 0,
//     totalPages: 1,
//     sortBy: "created_at",
//     sortDir: "DESC",
//     serviceType: "All",
//     status: "",
//     search: "",
//   });

//   // ui state
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const modalRef = useRef(null);

//   // filters (controlled -> triggers backend fetch)
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterType, setFilterType] = useState("All");
//   const [filterStatus, setFilterStatus] = useState("All");
//   const [currentPage, setCurrentPage] = useState(1);

//   // sorting controls
//   const [sortBy, setSortBy] = useState("created_at"); // 'created_at' | 'date' | 'price'
//   const [sortDir, setSortDir] = useState("DESC");     // 'ASC' | 'DESC'

//   // fetch from backend with pagination + filters
//   const fetchOrders = async () => {
//     try {
//       const { data } = await axios.get(`${URL}/accepted-servitor-orders`, {
//         params: {
//           page: currentPage,
//           limit: DEFAULT_LIMIT,
//           search: searchTerm,
//           status: filterStatus === "All" ? "" : filterStatus,
//           serviceType: filterType === "All" ? "" : filterType,
//           sortBy,
//           sortDir,
//         },
//       });

//       setOrders(Array.isArray(data?.data) ? data.data : []);
//       if (data?.meta) setMeta(data.meta);
//       else {
//         setMeta((m) => ({
//           ...m,
//           page: currentPage,
//           limit: DEFAULT_LIMIT,
//           total: Array.isArray(data) ? data.length : 0,
//           totalPages: 1,
//           sortBy,
//           sortDir,
//           serviceType: filterType,
//           status: filterStatus === "All" ? "" : filterStatus,
//           search: searchTerm,
//         }));
//       }
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//       setOrders([]);
//       setMeta((m) => ({ ...m, total: 0, totalPages: 1 }));
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentPage, searchTerm, filterType, filterStatus, sortBy, sortDir]);

//   // modal controls
//   const handleViewDetails = (order) => {
//     setSelectedOrder(order);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedOrder(null);
//     document.body.style.overflow = "auto";
//   };

//   // optional edit/delete hooks
//   const handleEditOrder = (order) => console.log("Editing order:", order);
//   const handleDeleteOrder = (order) => console.log("Deleting order:", order);

//   // backdrop/esc close
//   useEffect(() => {
//     const node = modalRef.current;
//     const handleBackdropClick = (e) => {
//       if (node && e.target === node) handleCloseModal();
//     };
//     const handleEscapeKey = (e) => {
//       if (e.key === "Escape") handleCloseModal();
//     };
//     if (node) node.addEventListener("click", handleBackdropClick);
//     document.addEventListener("keydown", handleEscapeKey);
//     return () => {
//       if (node) node.removeEventListener("click", handleBackdropClick);
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   const handlePrintReceipt = () => window.print();
//   const handleDownloadInvoice = () => console.log("Downloading invoice...");

//   const getServiceIcon = (type) => {
//     switch (type) {
//       case "Electrician":
//         return <FaBolt />;
//       case "Home Cleaning":
//         return <FaBroom />;
//       case "Plumber":
//         return <FaCogs />;
//       case "Gas Chula":
//         return <FaFire />;
//       case "AC Service":
//         return <FaSnowflake />;
//       case "Filter":
//         return <FaFilterIcon />;
//       case "Tutor Service":
//         return <FaUserGraduate />;
//       default:
//         return <FaCogs />;
//     }
//   };

//   const buildTimeline = (order) => {
//     const steps = [];
//     const safeDate = (v) => (v ? new Date(v) : null);

//     steps.push({
//       key: "placed",
//       label: "Order Placed",
//       time: safeDate(order.created_at),
//       dotClass: "completed",
//     });

//     if (order.accepted_at) {
//       steps.push({
//         key: "accepted",
//         label: "Order Accepted",
//         time: safeDate(order.accepted_at),
//         dotClass:
//           ["Accepted", "In-Progress", "Completed"].includes(order.status)
//             ? "completed"
//             : "inactive",
//       });
//     }

//     if (order.in_progress_at) {
//       steps.push({
//         key: "in_progress",
//         label: "Service In Progress",
//         time: safeDate(order.in_progress_at),
//         dotClass:
//           ["In-Progress", "Completed"].includes(order.status)
//             ? "in-progress"
//             : "inactive",
//       });
//     }

//     if (order.completed_at) {
//       steps.push({
//         key: "completed",
//         label: "Order Completed",
//         time: safeDate(order.completed_at),
//         dotClass: "arrived",
//       });
//     }

//     const st = String(order.status || "").toLowerCase();
//     if (st.includes("cancel")) {
//       steps.push({
//         key: "cancelled",
//         label: `Order ${order.status}`,
//         time: safeDate(order.updated_at) || new Date(),
//         dotClass: "cancelled",
//       });
//     }

//     return steps.filter((s) => s.time instanceof Date && !isNaN(s.time));
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1))
//       start = Math.max(2, total - (maxButtons - 2));

//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   const renderOrderDetails = () => {
//     if (!selectedOrder) return null;
//     const type = getServiceName(selectedOrder);
//     const icon = getServiceIcon(type);

//     // Build service-specific "details"
//     let details = {};
//     if (type === "Electrician") {
//       details = {
//         Installation: {
//           "New Ceiling Fan Installation": selectedOrder.new_ceiling_fan_installation,
//           "Ceiling Fan Installation": selectedOrder.ceiling_fan_installation,
//           "Ceiling Fan Uninstallation": selectedOrder.ceiling_fan_uninstallation,
//           "Light Installation": selectedOrder.light_installation,
//           "Exhaust Fan Installation": selectedOrder.exhaust_fan_installation,
//           "Doorbell Installation": selectedOrder.doorbell_installation,
//           "Switch Setup": selectedOrder.switch_setup,
//           "Socket Setup": selectedOrder.socket_setup,
//           "Regulator Setup": selectedOrder.regulator_setup,
//           "IPS Installation (Existing Line)": selectedOrder.ips_installation_existing_line,
//           "IPS New Line Installation": selectedOrder.ips_new_line_installation,
//         },
//         Repair: {
//           "Fan Coil Repair": selectedOrder.fan_coil_repair,
//           "Light Repair": selectedOrder.light_repair,
//         },
//         Maintenance: {
//           "Fan Coil New Winding": selectedOrder.fan_coil_new_winding,
//           "Capacitor Setup": selectedOrder.capacitor_setup,
//           "Exhaust Fan Cleaning": selectedOrder.exhaust_fan_cleaning,
//           "Main Circuit Board Setup": selectedOrder.main_circuit_board_setup,
//         },
//         Additional: {
//           "New Wiring Point": selectedOrder.new_wiring_point,
//           "Drill Hole Service": selectedOrder.drill_hole_service,
//           "Electrical Checkup": selectedOrder.Electrical_checkup ? "Yes" : "No",
//         },
//       };
//     } else if (type === "Home Cleaning") {
//       details = {
//         "Room Cleaning": {
//           "Bed Cleaning": safeNum(selectedOrder.bed, 0),
//           "Bathroom Cleaning": safeNum(selectedOrder.bath, 0),
//           "Drawing/Dining Cleaning": safeNum(selectedOrder.dra_din, 0),
//           "Balcony Cleaning": safeNum(selectedOrder.balcony, 0),
//           "Kitchen Cleaning": safeNum(selectedOrder.kitchen, 0),
//           "Satirs & Railing Cleaning": safeNum(selectedOrder.stairs_and_railing, 0),
//         },
//         "Additional Cleaning": {
//           "Window & Grill Cleaning": safeNum(selectedOrder.window_grill, 0),
//           "Furniture Cleaning": safeNum(selectedOrder.furniture_cleaning, 0),
//           "Cloth Washing": safeNum(selectedOrder.cloth, 0),
//           "Dish Washing": safeNum(selectedOrder.dish, 0),
//           "Carpet Cleaning": safeNum(selectedOrder.carpet_cleaning, 0),
//         },
//       };
//     } else if (type === "Plumber") {
//       details = {
//         Installation: {
//           "Angle Valve Setup":                              selectedOrder.angle_valve_setup,
//           "Basin Tap (Faucet) Setup":                       selectedOrder.basin_tap_setup,
//           "Magic Pipe (Flexible Drain) Setup":              selectedOrder.magic_pipe_setup,
//           "Basin Waste / Pop-Up Setup":                     selectedOrder.basin_waste_pop_up_setup,
//           "New Basin Setup (existing lines)":               selectedOrder.new_basin_setup_existing_lines,
//           "Bathroom Tap Setup":                             selectedOrder.bathroom_tap_bib_cock_setup,
//           "Tissue Holder Setup":                            selectedOrder.tissue_holder_setup,
//           "Hand Shower Setup":                              selectedOrder.hand_shower_setup,
//           "Soap Dish Setup":                                selectedOrder.soap_dish_setup,
//           "Bathroom Shelf Setup":                           selectedOrder.bathroom_shelf_setup,
//           "Looking Glass/Mirror Setup":                     selectedOrder.mirror_setup,
//           "Towel Hanger / Ring Setup":                      selectedOrder.towel_hanger_setup,
//           "Shower Head + Hose Setup":                       selectedOrder.shower_head_setup,
//           "Concealed Stopcock Valve Setup":                 selectedOrder.concealed_stopcock_setup,
//           "Floor Drain Net Setup":                          selectedOrder.floor_drain_net_setup,
//           "Toilet Seat Complete Installation":              selectedOrder.toilet_seat_complete_installation,
//           "High Commode Installation (existing lines)":     selectedOrder.high_commode_installation_existing_lines,
//           "Kitchen Sink Setup (existing lines)":            selectedOrder.kitchen_sink_setup_existing_lines,
//           "Geyser Installation":                            selectedOrder.geyser_installation,
//           "Washing Machine Point Setup (existing Line)":    selectedOrder.washing_machine_point_setup,
//         },
//         Repair: {
//           "Toilet Seat Cover Replacement":                  selectedOrder.toilet_seat_cover_replacement,
//           "Fill Valve Replacement (High Commode)":          selectedOrder.fill_valve_replacement,
//           "Blockage Clearing — High Commode":               selectedOrder.blockage_clearing_high_commode,
//           "Blockage Clearing — Low Commode":                selectedOrder.blockage_clearing_low_commode,
//             },
//         Maintenance: {
//           "Bathroom Drain Line Cleaning (per bathroom)":    selectedOrder.bathroom_drain_line_cleaning,
//           "Sink Blockage Cleaning":                         selectedOrder.sink_blockage_cleaning,
//         },
//         Additional: {
//           "Plumbing Checkup / Diagnosis":                   selectedOrder.issue_checkup ? "Yes" : "No",
//         },
//       };
//     } else if (type === "Gas Chula") {
//       details = {
//         Installation: {
//           "Cylinder Type":
//             selectedOrder.chulaCylinderType ||
//             selectedOrder.cylinderType ||
//             "-",
//           "New Chula Setup":
//             safeNum(selectedOrder.NewchulaSetup ?? selectedOrder.newChulaSetup, 0),
//           "Chula Setup": safeNum(selectedOrder.chulaSetup, 0),
//           "Burner Setup": safeNum(selectedOrder.burnerSetup, 0),
//         },
//         Maintenance: {
//           "Burner Cleaning": safeNum(selectedOrder.burnerCleaning, 0),
//           "Nozzle Replacement": safeNum(selectedOrder.nozzleReplacement, 0),
//           "Check Issues": toBoolYesNo(selectedOrder.checkIssues),
//         },
//       };
//     } else if (type === "AC Service") {
//        const n = (v) => (v == null || isNaN(Number(v)) ? 0 : Number(v));
//       details = {
//         Specifications: {
//           "AC Type": selectedOrder.acType || "-",
//           "AC Ton": selectedOrder.acTon || "-",
//         },
//         // Installation: {
//         //   "New Setup": safeNum(selectedOrder.new_setup ?? selectedOrder.newSetup, 0),
//         //   Installation: safeNum(selectedOrder.installation, 0),
//         //   Uninstallation: safeNum(selectedOrder.uninstallation, 0),
//         // },
//         // Maintenance: {
//         //   "Gas Refill": safeNum(selectedOrder.gas_refill ?? selectedOrder.gasRefill, 0),
//         //   Cleaning: safeNum(selectedOrder.cleaning, 0),
//         //   "Issue Checkup": toBoolYesNo(selectedOrder.issue_checkup ?? selectedOrder.issueCheckup),
//         // },

//         Installation: {
//           "AC Install (Outdoor Unit Inside)":  n(selectedOrder.installation_outdoor_inside),
//           "AC Install (Outdoor Unit Outside)": n(selectedOrder.installation_outdoor_outside),
//         },
//         Uninstallation: {
//           "AC Uninstall (Outdoor Unit Inside)":  n(selectedOrder.uninstallation_outdoor_inside),
//           "AC Uninstall (Outdoor Unit Outside)": n(selectedOrder.uninstallation_outdoor_outside),
//         },
//         Maintenance: {
//           "AC Cleaning (Outdoor Unit Inside)":  n(selectedOrder.cleaning_outdoor_inside),
//           "AC Cleaning (Outdoor Unit Outside)": n(selectedOrder.cleaning_outdoor_outside),
//           "Issue Checkup (units)":              n(selectedOrder.issue_checkup),
//         },
//       };
//     } else if (type === "Filter") {
//       details = {
//         Specifications: {
//           "Filter Type": selectedOrder.filter_type || "-",
//         },
//         Additional: {
//           "Issue Checkup": toBoolYesNo(selectedOrder.check_up),
//         },
//         Installation: {
//           "New Filter Setup": safeNum(selectedOrder.new_filter_setup, 0),
//           "Filter Installation": safeNum(selectedOrder.installation_filter, 0),
//           "Filter Uninstallation": safeNum(selectedOrder.uninstallation_filter, 0),
//         },
//         Maintenance: {
//           "Kit Replacement": safeNum(selectedOrder.kit_replacement, 0),
//           "Pipe Leak / Replace": safeNum(selectedOrder.pipe_leak_or_replace, 0),
//           "Full Servicing": safeNum(selectedOrder.full_servicing, 0),
//         },
//       };
//     } else if (type === "Tutor Service") {
//       const clean = (v) =>
//         v !== undefined &&
//         v !== null &&
//         String(v).trim() !== "" &&
//         String(v).trim().toLowerCase() !== "any";

//       const core = {};
//       if (clean(selectedOrder.subject)) core["Subject"] = selectedOrder.subject;
//       if (clean(selectedOrder.classLevel))
//         core["Class/Level"] = selectedOrder.classLevel;
//       if (clean(selectedOrder.medium)) core["Medium"] = selectedOrder.medium;

//       const schedule = {};
//       if (clean(selectedOrder.daysPerWeek))
//         schedule["Days per Week"] = `${selectedOrder.daysPerWeek}`;
//       if (clean(selectedOrder.hoursPerDay))
//         schedule["Hours per Day"] = `${selectedOrder.hoursPerDay}`;
//       if (clean(selectedOrder.salary))
//         schedule["Salary"] = `৳${selectedOrder.salary}`;

//       const prefs = {};
//       if (clean(selectedOrder.preferredTutorGender))
//         prefs["Preferred Tutor Gender"] = selectedOrder.preferredTutorGender;
//       if (clean(selectedOrder.priorityInstitution))
//         prefs["Priority Institution"] = selectedOrder.priorityInstitution;

//       details = {};
//       if (Object.keys(core).length) details["Tutoring"] = core;
//       if (Object.keys(schedule).length) details["Schedule & Budget"] = schedule;
//       if (Object.keys(prefs).length) details["Preferences"] = prefs;
//     }

//     return (
//       <div className="adminServitorOrders-modal">
//         <div className="adminServitorOrders-modal-header">
//           <button
//             className="adminServitorOrders-modal-close"
//             onClick={handleCloseModal}
//           >
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminServitorOrders-service-icon">{icon}</div>
//             <div>
//               <h2 className="adminServitorOrders-modal-title">Order Details</h2>
//               <p className="adminServitorOrders-modal-subtitle">
//                 Order #{selectedOrder.order_number} • {type} Service
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="adminServitorOrders-modal-body">
//           <div className="adminServitorOrders-summary-cards">
//             <div className="adminServitorOrders-summary-card adminServitorOrders-status-card">
//               <div>
//                 <p className="adminServitorOrders-detail-text">Status</p>
//                 <span
//                   className={`adminServitorOrders-badge-${normalizeStatusKey(
//                     selectedOrder.status
//                   )}`}
//                 >
//                   {selectedOrder.status}
//                 </span>
//               </div>
//               <FaCheckCircle size={24} style={{ color: "#22c55e" }} />
//             </div>
//             <div className="adminServitorOrders-summary-card adminServitorOrders-price-card">
//               <div>
//                 <p className="adminServitorOrders-detail-text">Total Amount</p>
//                 <p className="adminServitorOrders-price-value">
//                   ৳{selectedOrder.price}
//                 </p>
//               </div>
//               <FaDollarSign size={24} style={{ color: "#2563eb" }} />
//             </div>
//             <div className="adminServitorOrders-summary-card adminServitorOrders-date-card">
//               <div>
//                 <p className="adminServitorOrders-detail-text">Service Date</p>
//                 <p className="adminServitorOrders-date-value">
//                   {formatDate(selectedOrder.date)}
//                 </p>
//                 <p className="adminServitorOrders-time-value">
//                   {selectedOrder.time}
//                 </p>
//               </div>
//               <FaCalendar size={24} style={{ color: "#7c3aed" }} />
//             </div>
//           </div>

//           <div className="adminServitorOrders-detail-card">
//             <h3 className="adminServitorOrders-detail-title">
//               <FaUser style={{ marginRight: "8px", color: "#10b981" }} />
//               Customer Information
//             </h3>
//             <div className="adminServitorOrders-customer-grid">
//               <div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaUserCircle className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Customer Name
//                     </p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.User?.FirstName}{" "}
//                       {selectedOrder.User?.LastName}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaPhone className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Mobile Number
//                     </p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.User?.mobile}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaIdBadge className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">User ID</p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.User?.Id}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaMapMarkerAlt className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Service Location
//                     </p>
//                     <p className="adminServitorOrders-detail-value">
//                       {[selectedOrder.City, selectedOrder.Area, selectedOrder.Address]
//                         .filter(Boolean)
//                         .join(" - ")}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="adminServitorOrders-detail-card">
//             <h3 className="adminServitorOrders-detail-title">
//               {getServiceName(selectedOrder)} Service Details
//             </h3>
//             <div className="adminServitorOrders-service-grid">
//               {/* ✅ Use details directly to avoid unused variable warnings */}
//               {Object.entries(details).map(([category, items]) => (
//                 <div key={category} className="adminServitorOrders-service-category">
//                   <h4 className="adminServitorOrders-category-title">
//                     {category === "Installation" && (
//                       <FaPlusCircle style={{ marginRight: "8px", color: "#22c55e" }} />
//                     )}
//                     {category === "Repair" && (
//                       <FaWrench style={{ marginRight: "8px", color: "#f59e0b" }} />
//                     )}
//                     {category === "Maintenance" && (
//                       <FaCogs style={{ marginRight: "8px", color: "#3b82f6" }} />
//                     )}
//                     {category === "Additional" && (
//                       <FaStar style={{ marginRight: "8px", color: "#7c3aed" }} />
//                     )}
//                     {category === "Room Cleaning" && (
//                       <FaBroom style={{ marginRight: "8px", color: "#10b981" }} />
//                     )}
//                     {category === "Additional Cleaning" && (
//                       <FaStar style={{ marginRight: "8px", color: "#7c3aed" }} />
//                     )}
//                     {category === "Specifications" && (
//                       <FaSnowflake style={{ marginRight: "8px", color: "#7c3aed" }} />
//                     )}
//                     {category === "Tutoring" && (
//                       <FaUserGraduate style={{ marginRight: "8px", color: "#2563eb" }} />
//                     )}
//                     {category === "Schedule & Budget" && (
//                       <FaCalendar style={{ marginRight: "8px", color: "#7c3aed" }} />
//                     )}
//                     {category === "Preferences" && (
//                       <FaStar style={{ marginRight: "8px", color: "#f59e0b" }} />
//                     )}
//                     {category}
//                   </h4>
//                   <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//                     {Object.entries(items).map(([key, value]) => {
//                       const isOff =
//                         value === "No" || value === 0 || value === "-" || value === null;
//                       return (
//                         <div
//                           key={key}
//                           className={`adminServitorOrders-service-item ${isOff ? "inactive" : ""}`}
//                         >
//                           <span
//                             className={`adminServitorOrders-service-name ${isOff ? "inactive" : ""}`}
//                           >
//                             {key}
//                           </span>
//                           <span
//                             className={`adminServitorOrders-service-value${
//                               isOff ? "-inactive" : ""
//                             }`}
//                           >
//                             {value}
//                           </span>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="adminServitorOrders-detail-card">
//             <h3 className="adminServitorOrders-detail-title">
//               <FaClock style={{ marginRight: "8px", color: "#10b981" }} />
//               Order Timeline
//             </h3>
//             <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//               {buildTimeline(selectedOrder).map((step) => (
//                 <div key={step.key} className="adminServitorOrders-timeline-item">
//                   {step.key === "cancelled" ? (
//                     <FaTimes size={16} className="adminServitorOrders-timeline-cancel-icon" />
//                   ) : (
//                     <div className={`adminServitorOrders-timeline-dot ${step.dotClass}`}></div>
//                   )}
//                   <div className="adminServitorOrders-timeline-content">
//                     <h4>{step.label}</h4>
//                     <p>{new Date(step.time).toLocaleString()}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {String(selectedOrder.status || "").toLowerCase().includes("cancel") &&
//             selectedOrder.cancellation_feedback && (
//               <div className="adminServitorOrders-detail-card">
//                 <h3 className="adminServitorOrders-detail-title">
//                   <FaTimes style={{ marginRight: "8px", color: "#ef4444" }} />
//                   Cancellation Details
//                 </h3>
//                 <p className="adminServitorOrders-detail-value">
//                   {selectedOrder.cancellation_feedback}
//                 </p>
//               </div>
//             )}
//         </div>

//         <div className="adminServitorOrders-modal-footer">
//           <div className="adminServitorOrders-footer-buttons">
//             <button
//               className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-print"
//               onClick={handlePrintReceipt}
//             >
//               <FaPrint />
//               Print Receipt
//             </button>
//             <button
//               className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-download"
//               onClick={handleDownloadInvoice}
//             >
//               <FaDownload />
//               Download Invoice
//             </button>
//             <button
//               className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaCheck />
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Container fluid className="adminServitorOrders-container">
//       <Card className="adminServitorOrders-card">
//         <Card.Body>
//           <Card.Header className="adminServitorOrders-header">
//             <h4 className="adminServitorOrders-title">Servitor Accepted Orders</h4>
//           </Card.Header>

//           {/* Filters */}
//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Order Number, User ID or Mobile Number"
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                   className="adminServitorOrders-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="statusFilter">
//                 <Form.Select
//                   value={filterStatus}
//                   onChange={(e) => {
//                     setFilterStatus(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                   className="adminServitorOrders-filter-select"
//                 >
//                   <option value="All">All Statuses</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="In-Progress">In-Progress</option>
//                   <option value="Completed">Completed</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* Service filter + sort controls */}
//           <div className="adminServitorOrders-filter-container" style={{gap:8, display:"flex", flexWrap:"wrap", alignItems:"center"}}>
//             {[
//               "All",
//               "Electrician",
//               "Home Cleaning",
//               "Plumber",
//               "Gas Chula",
//               "AC Service",
//               "Filter",
//               "Tutor Service",
//             ].map((type) => (
//               <Button
//                 key={type}
//                 variant={filterType === type ? "primary" : "outline-primary"}
//                 className="adminServitorOrders-filter-btn"
//                 onClick={() => {
//                   setFilterType(type);
//                   setCurrentPage(1);
//                 }}
//               >
//                 {type}
//               </Button>
//             ))}

//             <Form.Select
//               style={{ width: 160, marginLeft: "auto" }}
//               value={sortBy}
//               onChange={(e) => {
//                 setSortBy(e.target.value);
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="created_at">Sort by Created</option>
//               <option value="date">Sort by Service Date</option>
//               <option value="price">Sort by Price</option>
//             </Form.Select>
//             <Form.Select
//               style={{ width: 120 }}
//               value={sortDir}
//               onChange={(e) => {
//                 setSortDir(e.target.value);
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="DESC">DESC</option>
//               <option value="ASC">ASC</option>
//             </Form.Select>
//           </div>

//           <Table striped bordered hover responsive className="adminServitorOrders-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Order number</th>
//                 <th>User ID</th>
//                 <th>Mobile</th>
//                 <th>Service</th>
//                 <th>Servitor ID</th>
//                 <th>Status</th>
//                 <th>Price</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {orders.map((order, index) => (
//                 <tr key={order.Id ?? `${order.order_number}-${index}`}>
//                   <td>{index + 1 + (meta.page - 1) * meta.limit}</td>
//                   <td>{order.order_number}</td>
//                   <td>{order.User?.Id}</td>
//                   <td>{order.User?.mobile}</td>
//                   <td>{getServiceName(order)}</td>
//                   <td>{order.Servitor?.Id}</td>
//                   <td>
//                     <Badge className={`adminServitorOrders-badge-${normalizeStatusKey(order.status)}`}>
//                       {order.status}
//                     </Badge>
//                   </td>
//                   <td>{order.price}Tk</td>
//                   <td>{formatDate(order.date)}</td>
//                   <td>{order.time}</td>
//                   <td>
//                     <div className="adminServitorOrders-action-group">
//                       <Button
//                         variant="outline-primary"
//                         size="sm"
//                         className="adminServitorOrders-action-btn"
//                         onClick={() => handleViewDetails(order)}
//                       >
//                         <BsEye size={16} />
//                       </Button>
//                       <Button
//                         variant="outline-edit"
//                         size="sm"
//                         className="adminServitorOrders-action-btn"
//                         onClick={() => handleEditOrder(order)}
//                       >
//                         <FaEdit size={16} />
//                       </Button>
//                       <Button
//                         variant="outline-danger"
//                         size="sm"
//                         className="adminServitorOrders-action-btn"
//                         onClick={() => handleDeleteOrder(order)}
//                       >
//                         <FaTrash size={16} />
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//               {orders.length === 0 && (
//                 <tr>
//                   <td colSpan={11} style={{ textAlign: "center" }}>
//                     No orders found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>

//           {/* Pagination from backend meta */}
//           <Pagination>
//             <Pagination.First
//               onClick={() => setCurrentPage(1)}
//               disabled={meta.page === 1}
//             />
//             <Pagination.Prev
//               onClick={() => setCurrentPage(meta.page - 1)}
//               disabled={meta.page === 1}
//             />
//             {getPageItems(meta.totalPages, meta.page).map((item, idx) => {
//               if (item === "start-ellipsis" || item === "end-ellipsis") {
//                 return <Pagination.Ellipsis key={item + idx} disabled />;
//               }
//               return (
//                 <Pagination.Item
//                   key={item}
//                   active={item === meta.page}
//                   onClick={() => setCurrentPage(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               );
//             })}
//             <Pagination.Next
//               onClick={() => setCurrentPage(meta.page + 1)}
//               disabled={meta.page === meta.totalPages}
//             />
//             <Pagination.Last
//               onClick={() => setCurrentPage(meta.totalPages)}
//               disabled={meta.page === meta.totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div className="adminServitorOrders-modal-backdrop" ref={modalRef}>
//           {renderOrderDetails()}
//         </div>
//       )}
//     </Container>
//   );
// };

// export default ServitorConfirmOrders;


// ***** Upper code is all perfect all checked (3-Nov-2025) ***** //



// ***** Update Admin can Update order status for when custom order ***** //
// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import {
//   Table,
//   Container,
//   Card,
//   Pagination,
//   Badge,
//   Button,
//   InputGroup,
//   Form,
//   Row,
//   Col,
//   Modal,           
//   FloatingLabel,
// } from "react-bootstrap";

// import { BsEye } from "react-icons/bs";

// import {
//   FaTimes,
//   FaBolt,
//   FaUser,
//   FaCheckCircle,
//   FaDollarSign,
//   FaCalendar,
//   FaPlusCircle,
//   FaWrench,
//   FaCogs,
//   FaStar,
//   FaUserCircle,
//   FaPhone,
//   FaIdBadge,
//   FaMapMarkerAlt,
//   FaClock,
//   FaPrint,
//   FaDownload,
//   FaCheck,
//   FaEdit,
//   FaTrash,
//   FaBroom,
//   FaFire,
//   FaSnowflake,
//   FaFilter as FaFilterIcon,
//   FaUserGraduate,
// } from "react-icons/fa";
// import "./ServitorConfirmOrders.css";
// import { formatDate } from "../../dateTimefrontpart";
// import { URL } from "../../../config";

// const DEFAULT_LIMIT = 10;

// const normalizeStatusKey = (s) =>
//   (s ? String(s).toLowerCase().replace(/\s+/g, "-") : "unknown");

// const getServiceName = (row) =>
//   row?.Service?.services_name ||
//   row?.service_name ||
//   row?.service ||
//   row?.serviceType ||
//   "Service";

// const toBoolYesNo = (v) => (v ? "Yes" : "No");
// const safeNum = (v, fallback = 0) => (v === 0 || v ? v : fallback);

// const ServitorConfirmOrders = () => {
//   // data
//   const [orders, setOrders] = useState([]);
//   const [meta, setMeta] = useState({
//     page: 1,
//     limit: DEFAULT_LIMIT,
//     total: 0,
//     totalPages: 1,
//     sortBy: "created_at",
//     sortDir: "DESC",
//     serviceType: "All",
//     status: "",
//     search: "",
//   });

//   // ui state
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const modalRef = useRef(null);

//   // NEW: edit modal state
//     const [showEdit, setShowEdit] = useState(false);
//     const [savingEdit, setSavingEdit] = useState(false);
//     const [editStatus, setEditStatus] = useState("Pending");
//     const [editRating, setEditRating] = useState(5);
//     const [editFeedback, setEditFeedback] = useState("");

//   // filters (controlled -> triggers backend fetch)
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterType, setFilterType] = useState("All");
//   const [filterStatus, setFilterStatus] = useState("All");
//   const [currentPage, setCurrentPage] = useState(1);

//   // sorting controls
//   const [sortBy, setSortBy] = useState("created_at"); // 'created_at' | 'date' | 'price'
//   const [sortDir, setSortDir] = useState("DESC");     // 'ASC' | 'DESC'

//   // fetch from backend with pagination + filters
//   const fetchOrders = async () => {
//     try {
//       const { data } = await axios.get(`${URL}/accepted-servitor-orders`, {
//         params: {
//           page: currentPage,
//           limit: DEFAULT_LIMIT,
//           search: searchTerm,
//           status: filterStatus === "All" ? "" : filterStatus,
//           serviceType: filterType === "All" ? "" : filterType,
//           sortBy,
//           sortDir,
//         },
//       });

//       setOrders(Array.isArray(data?.data) ? data.data : []);
//       if (data?.meta) setMeta(data.meta);
//       else {
//         setMeta((m) => ({
//           ...m,
//           page: currentPage,
//           limit: DEFAULT_LIMIT,
//           total: Array.isArray(data) ? data.length : 0,
//           totalPages: 1,
//           sortBy,
//           sortDir,
//           serviceType: filterType,
//           status: filterStatus === "All" ? "" : filterStatus,
//           search: searchTerm,
//         }));
//       }
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//       setOrders([]);
//       setMeta((m) => ({ ...m, total: 0, totalPages: 1 }));
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentPage, searchTerm, filterType, filterStatus, sortBy, sortDir]);

//   // modal controls
//   const handleViewDetails = (order) => {
//     setSelectedOrder(order);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedOrder(null);
//     document.body.style.overflow = "auto";
//   };

//   // optional edit/delete hooks
//   const handleEditOrder = (order) => {
//     setSelectedOrder(order);
//     setEditStatus(order.status === "Completed" ? "Completed" : "Pending");
//     setEditRating(5);
//     setEditFeedback("");
//     setShowEdit(true);
//   };
//   const handleDeleteOrder = (order) => console.log("Deleting order:", order);

//   // backdrop/esc close
//   useEffect(() => {
//     const node = modalRef.current;
//     const handleBackdropClick = (e) => {
//       if (node && e.target === node) handleCloseModal();
//     };
//     const handleEscapeKey = (e) => {
//       if (e.key === "Escape") handleCloseModal();
//     };
//     if (node) node.addEventListener("click", handleBackdropClick);
//     document.addEventListener("keydown", handleEscapeKey);
//     return () => {
//       if (node) node.removeEventListener("click", handleBackdropClick);
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   const handlePrintReceipt = () => window.print();
//   const handleDownloadInvoice = () => console.log("Downloading invoice...");

//   const getServiceIcon = (type) => {
//     switch (type) {
//       case "Electrician":
//         return <FaBolt />;
//       case "Home Cleaning":
//         return <FaBroom />;
//       case "Plumber":
//         return <FaCogs />;
//       case "Gas Chula":
//         return <FaFire />;
//       case "AC Service":
//         return <FaSnowflake />;
//       case "Filter":
//         return <FaFilterIcon />;
//       case "Tutor Service":
//         return <FaUserGraduate />;
//       default:
//         return <FaCogs />;
//     }
//   };

//   const buildTimeline = (order) => {
//     const steps = [];
//     const safeDate = (v) => (v ? new Date(v) : null);

//     steps.push({
//       key: "placed",
//       label: "Order Placed",
//       time: safeDate(order.created_at),
//       dotClass: "completed",
//     });

//     if (order.accepted_at) {
//       steps.push({
//         key: "accepted",
//         label: "Order Accepted",
//         time: safeDate(order.accepted_at),
//         dotClass:
//           ["Accepted", "In-Progress", "Completed"].includes(order.status)
//             ? "completed"
//             : "inactive",
//       });
//     }

//     if (order.in_progress_at) {
//       steps.push({
//         key: "in_progress",
//         label: "Service In Progress",
//         time: safeDate(order.in_progress_at),
//         dotClass:
//           ["In-Progress", "Completed"].includes(order.status)
//             ? "in-progress"
//             : "inactive",
//       });
//     }

//     if (order.completed_at) {
//       steps.push({
//         key: "completed",
//         label: "Order Completed",
//         time: safeDate(order.completed_at),
//         dotClass: "arrived",
//       });
//     }

//     const st = String(order.status || "").toLowerCase();
//     if (st.includes("cancel")) {
//       steps.push({
//         key: "cancelled",
//         label: `Order ${order.status}`,
//         time: safeDate(order.updated_at) || new Date(),
//         dotClass: "cancelled",
//       });
//     }

//     return steps.filter((s) => s.time instanceof Date && !isNaN(s.time));
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1))
//       start = Math.max(2, total - (maxButtons - 2));

//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   const renderOrderDetails = () => {
//     if (!selectedOrder) return null;
//     const type = getServiceName(selectedOrder);
//     const icon = getServiceIcon(type);

//     // Build service-specific "details"
//     let details = {};
//     if (type === "Electrician") {
//       details = {
//         Installation: {
//           "New Ceiling Fan Installation": selectedOrder.new_ceiling_fan_installation,
//           "Ceiling Fan Installation": selectedOrder.ceiling_fan_installation,
//           "Ceiling Fan Uninstallation": selectedOrder.ceiling_fan_uninstallation,
//           "Light Installation": selectedOrder.light_installation,
//           "Exhaust Fan Installation": selectedOrder.exhaust_fan_installation,
//           "Doorbell Installation": selectedOrder.doorbell_installation,
//           "Switch Setup": selectedOrder.switch_setup,
//           "Socket Setup": selectedOrder.socket_setup,
//           "Regulator Setup": selectedOrder.regulator_setup,
//           "IPS Installation (Existing Line)": selectedOrder.ips_installation_existing_line,
//           "IPS New Line Installation": selectedOrder.ips_new_line_installation,
//         },
//         Repair: {
//           "Fan Coil Repair": selectedOrder.fan_coil_repair,
//           "Light Repair": selectedOrder.light_repair,
//         },
//         Maintenance: {
//           "Fan Coil New Winding": selectedOrder.fan_coil_new_winding,
//           "Capacitor Setup": selectedOrder.capacitor_setup,
//           "Exhaust Fan Cleaning": selectedOrder.exhaust_fan_cleaning,
//           "Main Circuit Board Setup": selectedOrder.main_circuit_board_setup,
//         },
//         Additional: {
//           "New Wiring Point": selectedOrder.new_wiring_point,
//           "Drill Hole Service": selectedOrder.drill_hole_service,
//           "Electrical Checkup": selectedOrder.Electrical_checkup ? "Yes" : "No",
//         },
//       };
//     } else if (type === "Home Cleaning") {
//       details = {
//         "Room Cleaning": {
//           "Bed Cleaning": safeNum(selectedOrder.bed, 0),
//           "Bathroom Cleaning": safeNum(selectedOrder.bath, 0),
//           "Drawing/Dining Cleaning": safeNum(selectedOrder.dra_din, 0),
//           "Balcony Cleaning": safeNum(selectedOrder.balcony, 0),
//           "Kitchen Cleaning": safeNum(selectedOrder.kitchen, 0),
//           "Satirs & Railing Cleaning": safeNum(selectedOrder.stairs_and_railing, 0),
//         },
//         "Additional Cleaning": {
//           "Window & Grill Cleaning": safeNum(selectedOrder.window_grill, 0),
//           "Furniture Cleaning": safeNum(selectedOrder.furniture_cleaning, 0),
//           "Cloth Washing": safeNum(selectedOrder.cloth, 0),
//           "Dish Washing": safeNum(selectedOrder.dish, 0),
//           "Carpet Cleaning": safeNum(selectedOrder.carpet_cleaning, 0),
//         },
//       };
//     } else if (type === "Plumber") {
//       details = {
//         Installation: {
//           "Angle Valve Setup":                              selectedOrder.angle_valve_setup,
//           "Basin Tap (Faucet) Setup":                       selectedOrder.basin_tap_setup,
//           "Magic Pipe (Flexible Drain) Setup":              selectedOrder.magic_pipe_setup,
//           "Basin Waste / Pop-Up Setup":                     selectedOrder.basin_waste_pop_up_setup,
//           "New Basin Setup (existing lines)":               selectedOrder.new_basin_setup_existing_lines,
//           "Bathroom Tap Setup":                             selectedOrder.bathroom_tap_bib_cock_setup,
//           "Tissue Holder Setup":                            selectedOrder.tissue_holder_setup,
//           "Hand Shower Setup":                              selectedOrder.hand_shower_setup,
//           "Soap Dish Setup":                                selectedOrder.soap_dish_setup,
//           "Bathroom Shelf Setup":                           selectedOrder.bathroom_shelf_setup,
//           "Looking Glass/Mirror Setup":                     selectedOrder.mirror_setup,
//           "Towel Hanger / Ring Setup":                      selectedOrder.towel_hanger_setup,
//           "Shower Head + Hose Setup":                       selectedOrder.shower_head_setup,
//           "Concealed Stopcock Valve Setup":                 selectedOrder.concealed_stopcock_setup,
//           "Floor Drain Net Setup":                          selectedOrder.floor_drain_net_setup,
//           "Toilet Seat Complete Installation":              selectedOrder.toilet_seat_complete_installation,
//           "High Commode Installation (existing lines)":     selectedOrder.high_commode_installation_existing_lines,
//           "Kitchen Sink Setup (existing lines)":            selectedOrder.kitchen_sink_setup_existing_lines,
//           "Geyser Installation":                            selectedOrder.geyser_installation,
//           "Washing Machine Point Setup (existing Line)":    selectedOrder.washing_machine_point_setup,
//         },
//         Repair: {
//           "Toilet Seat Cover Replacement":                  selectedOrder.toilet_seat_cover_replacement,
//           "Fill Valve Replacement (High Commode)":          selectedOrder.fill_valve_replacement,
//           "Blockage Clearing — High Commode":               selectedOrder.blockage_clearing_high_commode,
//           "Blockage Clearing — Low Commode":                selectedOrder.blockage_clearing_low_commode,
//             },
//         Maintenance: {
//           "Bathroom Drain Line Cleaning (per bathroom)":    selectedOrder.bathroom_drain_line_cleaning,
//           "Sink Blockage Cleaning":                         selectedOrder.sink_blockage_cleaning,
//         },
//         Additional: {
//           "Plumbing Checkup / Diagnosis":                   selectedOrder.issue_checkup ? "Yes" : "No",
//         },
//       };
//     } else if (type === "Gas Chula") {
//       details = {
//         Installation: {
//           "Cylinder Type":
//             selectedOrder.chulaCylinderType ||
//             selectedOrder.cylinderType ||
//             "-",
//           "New Chula Setup":
//             safeNum(selectedOrder.NewchulaSetup ?? selectedOrder.newChulaSetup, 0),
//           "Chula Setup": safeNum(selectedOrder.chulaSetup, 0),
//           "Burner Setup": safeNum(selectedOrder.burnerSetup, 0),
//         },
//         Maintenance: {
//           "Burner Cleaning": safeNum(selectedOrder.burnerCleaning, 0),
//           "Nozzle Replacement": safeNum(selectedOrder.nozzleReplacement, 0),
//           "Check Issues": toBoolYesNo(selectedOrder.checkIssues),
//         },
//       };
//     } else if (type === "AC Service") {
//        const n = (v) => (v == null || isNaN(Number(v)) ? 0 : Number(v));
//       details = {
//         Specifications: {
//           "AC Type": selectedOrder.acType || "-",
//           "AC Ton": selectedOrder.acTon || "-",
//         },
//         // Installation: {
//         //   "New Setup": safeNum(selectedOrder.new_setup ?? selectedOrder.newSetup, 0),
//         //   Installation: safeNum(selectedOrder.installation, 0),
//         //   Uninstallation: safeNum(selectedOrder.uninstallation, 0),
//         // },
//         // Maintenance: {
//         //   "Gas Refill": safeNum(selectedOrder.gas_refill ?? selectedOrder.gasRefill, 0),
//         //   Cleaning: safeNum(selectedOrder.cleaning, 0),
//         //   "Issue Checkup": toBoolYesNo(selectedOrder.issue_checkup ?? selectedOrder.issueCheckup),
//         // },

//         Installation: {
//           "AC Install (Outdoor Unit Inside)":  n(selectedOrder.installation_outdoor_inside),
//           "AC Install (Outdoor Unit Outside)": n(selectedOrder.installation_outdoor_outside),
//         },
//         Uninstallation: {
//           "AC Uninstall (Outdoor Unit Inside)":  n(selectedOrder.uninstallation_outdoor_inside),
//           "AC Uninstall (Outdoor Unit Outside)": n(selectedOrder.uninstallation_outdoor_outside),
//         },
//         Maintenance: {
//           "AC Cleaning (Outdoor Unit Inside)":  n(selectedOrder.cleaning_outdoor_inside),
//           "AC Cleaning (Outdoor Unit Outside)": n(selectedOrder.cleaning_outdoor_outside),
//           "Issue Checkup (units)":              n(selectedOrder.issue_checkup),
//         },
//       };
//     } else if (type === "Filter") {
//       details = {
//         Specifications: {
//           "Filter Type": selectedOrder.filter_type || "-",
//         },
//         Additional: {
//           "Issue Checkup": toBoolYesNo(selectedOrder.check_up),
//         },
//         Installation: {
//           "New Filter Setup": safeNum(selectedOrder.new_filter_setup, 0),
//           "Filter Installation": safeNum(selectedOrder.installation_filter, 0),
//           "Filter Uninstallation": safeNum(selectedOrder.uninstallation_filter, 0),
//         },
//         Maintenance: {
//           "Kit Replacement": safeNum(selectedOrder.kit_replacement, 0),
//           "Pipe Leak / Replace": safeNum(selectedOrder.pipe_leak_or_replace, 0),
//           "Full Servicing": safeNum(selectedOrder.full_servicing, 0),
//         },
//       };
//     } else if (type === "Tutor Service") {
//       const clean = (v) =>
//         v !== undefined &&
//         v !== null &&
//         String(v).trim() !== "" &&
//         String(v).trim().toLowerCase() !== "any";

//       const core = {};
//       if (clean(selectedOrder.subject)) core["Subject"] = selectedOrder.subject;
//       if (clean(selectedOrder.classLevel))
//         core["Class/Level"] = selectedOrder.classLevel;
//       if (clean(selectedOrder.medium)) core["Medium"] = selectedOrder.medium;

//       const schedule = {};
//       if (clean(selectedOrder.daysPerWeek))
//         schedule["Days per Week"] = `${selectedOrder.daysPerWeek}`;
//       if (clean(selectedOrder.hoursPerDay))
//         schedule["Hours per Day"] = `${selectedOrder.hoursPerDay}`;
//       if (clean(selectedOrder.salary))
//         schedule["Salary"] = `৳${selectedOrder.salary}`;

//       const prefs = {};
//       if (clean(selectedOrder.preferredTutorGender))
//         prefs["Preferred Tutor Gender"] = selectedOrder.preferredTutorGender;
//       if (clean(selectedOrder.priorityInstitution))
//         prefs["Priority Institution"] = selectedOrder.priorityInstitution;

//       details = {};
//       if (Object.keys(core).length) details["Tutoring"] = core;
//       if (Object.keys(schedule).length) details["Schedule & Budget"] = schedule;
//       if (Object.keys(prefs).length) details["Preferences"] = prefs;
//     }

//     return (
//       <div className="adminServitorOrders-modal">
//         <div className="adminServitorOrders-modal-header">
//           <button
//             className="adminServitorOrders-modal-close"
//             onClick={handleCloseModal}
//           >
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminServitorOrders-service-icon">{icon}</div>
//             <div>
//               <h2 className="adminServitorOrders-modal-title">Order Details</h2>
//               <p className="adminServitorOrders-modal-subtitle">
//                 Order #{selectedOrder.order_number} • {type} Service
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="adminServitorOrders-modal-body">
//           <div className="adminServitorOrders-summary-cards">
//             <div className="adminServitorOrders-summary-card adminServitorOrders-status-card">
//               <div>
//                 <p className="adminServitorOrders-detail-text">Status</p>
//                 <span
//                   className={`adminServitorOrders-badge-${normalizeStatusKey(
//                     selectedOrder.status
//                   )}`}
//                 >
//                   {selectedOrder.status}
//                 </span>
//               </div>
//               <FaCheckCircle size={24} style={{ color: "#22c55e" }} />
//             </div>
//             <div className="adminServitorOrders-summary-card adminServitorOrders-price-card">
//               <div>
//                 <p className="adminServitorOrders-detail-text">Total Amount</p>
//                 <p className="adminServitorOrders-price-value">
//                   ৳{selectedOrder.price}
//                 </p>
//               </div>
//               <FaDollarSign size={24} style={{ color: "#2563eb" }} />
//             </div>
//             <div className="adminServitorOrders-summary-card adminServitorOrders-date-card">
//               <div>
//                 <p className="adminServitorOrders-detail-text">Service Date</p>
//                 <p className="adminServitorOrders-date-value">
//                   {formatDate(selectedOrder.date)}
//                 </p>
//                 <p className="adminServitorOrders-time-value">
//                   {selectedOrder.time}
//                 </p>
//               </div>
//               <FaCalendar size={24} style={{ color: "#7c3aed" }} />
//             </div>
//           </div>

//           <div className="adminServitorOrders-detail-card">
//             <h3 className="adminServitorOrders-detail-title">
//               <FaUser style={{ marginRight: "8px", color: "#10b981" }} />
//               Customer Information
//             </h3>
//             <div className="adminServitorOrders-customer-grid">
//               <div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaUserCircle className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Customer Name
//                     </p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.User?.FirstName}{" "}
//                       {selectedOrder.User?.LastName}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaPhone className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Mobile Number
//                     </p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.User?.mobile}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaIdBadge className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">User ID</p>
//                     <p className="adminServitorOrders-detail-value">
//                       {selectedOrder.User?.Id}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="adminServitorOrders-customer-info">
//                   <FaMapMarkerAlt className="adminServitorOrders-customer-icon" />
//                   <div>
//                     <p className="adminServitorOrders-detail-text">
//                       Service Location
//                     </p>
//                     <p className="adminServitorOrders-detail-value">
//                       {[selectedOrder.City, selectedOrder.Area, selectedOrder.Address]
//                         .filter(Boolean)
//                         .join(" - ")}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="adminServitorOrders-detail-card">
//             <h3 className="adminServitorOrders-detail-title">
//               {getServiceName(selectedOrder)} Service Details
//             </h3>
//             <div className="adminServitorOrders-service-grid">
//               {/* ✅ Use details directly to avoid unused variable warnings */}
//               {Object.entries(details).map(([category, items]) => (
//                 <div key={category} className="adminServitorOrders-service-category">
//                   <h4 className="adminServitorOrders-category-title">
//                     {category === "Installation" && (
//                       <FaPlusCircle style={{ marginRight: "8px", color: "#22c55e" }} />
//                     )}
//                     {category === "Repair" && (
//                       <FaWrench style={{ marginRight: "8px", color: "#f59e0b" }} />
//                     )}
//                     {category === "Maintenance" && (
//                       <FaCogs style={{ marginRight: "8px", color: "#3b82f6" }} />
//                     )}
//                     {category === "Additional" && (
//                       <FaStar style={{ marginRight: "8px", color: "#7c3aed" }} />
//                     )}
//                     {category === "Room Cleaning" && (
//                       <FaBroom style={{ marginRight: "8px", color: "#10b981" }} />
//                     )}
//                     {category === "Additional Cleaning" && (
//                       <FaStar style={{ marginRight: "8px", color: "#7c3aed" }} />
//                     )}
//                     {category === "Specifications" && (
//                       <FaSnowflake style={{ marginRight: "8px", color: "#7c3aed" }} />
//                     )}
//                     {category === "Tutoring" && (
//                       <FaUserGraduate style={{ marginRight: "8px", color: "#2563eb" }} />
//                     )}
//                     {category === "Schedule & Budget" && (
//                       <FaCalendar style={{ marginRight: "8px", color: "#7c3aed" }} />
//                     )}
//                     {category === "Preferences" && (
//                       <FaStar style={{ marginRight: "8px", color: "#f59e0b" }} />
//                     )}
//                     {category}
//                   </h4>
//                   <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//                     {Object.entries(items).map(([key, value]) => {
//                       const isOff =
//                         value === "No" || value === 0 || value === "-" || value === null;
//                       return (
//                         <div
//                           key={key}
//                           className={`adminServitorOrders-service-item ${isOff ? "inactive" : ""}`}
//                         >
//                           <span
//                             className={`adminServitorOrders-service-name ${isOff ? "inactive" : ""}`}
//                           >
//                             {key}
//                           </span>
//                           <span
//                             className={`adminServitorOrders-service-value${
//                               isOff ? "-inactive" : ""
//                             }`}
//                           >
//                             {value}
//                           </span>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="adminServitorOrders-detail-card">
//             <h3 className="adminServitorOrders-detail-title">
//               <FaClock style={{ marginRight: "8px", color: "#10b981" }} />
//               Order Timeline
//             </h3>
//             <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//               {buildTimeline(selectedOrder).map((step) => (
//                 <div key={step.key} className="adminServitorOrders-timeline-item">
//                   {step.key === "cancelled" ? (
//                     <FaTimes size={16} className="adminServitorOrders-timeline-cancel-icon" />
//                   ) : (
//                     <div className={`adminServitorOrders-timeline-dot ${step.dotClass}`}></div>
//                   )}
//                   <div className="adminServitorOrders-timeline-content">
//                     <h4>{step.label}</h4>
//                     <p>{new Date(step.time).toLocaleString()}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {String(selectedOrder.status || "").toLowerCase().includes("cancel") &&
//             selectedOrder.cancellation_feedback && (
//               <div className="adminServitorOrders-detail-card">
//                 <h3 className="adminServitorOrders-detail-title">
//                   <FaTimes style={{ marginRight: "8px", color: "#ef4444" }} />
//                   Cancellation Details
//                 </h3>
//                 <p className="adminServitorOrders-detail-value">
//                   {selectedOrder.cancellation_feedback}
//                 </p>
//               </div>
//             )}
//         </div>

//         <div className="adminServitorOrders-modal-footer">
//           <div className="adminServitorOrders-footer-buttons">
//             <button
//               className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-print"
//               onClick={handlePrintReceipt}
//             >
//               <FaPrint />
//               Print Receipt
//             </button>
//             <button
//               className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-download"
//               onClick={handleDownloadInvoice}
//             >
//               <FaDownload />
//               Download Invoice
//             </button>
//             <button
//               className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaCheck />
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };



//   // for pilot project manually can update NEW: submit edit (Complete or Pending)
//   const submitEdit = async () => {
//     if (!selectedOrder) return;
//     try {
//       setSavingEdit(true);

//       const id = selectedOrder.Id;
//       const serviceType = getServiceName(selectedOrder);
//       const price = Number(selectedOrder.price) || 0;

//       if (editStatus === "Completed") {
//         // POST to completeTransaction API
//         // Backend controller: completeTransaction(req,res) uses req.params.id
//         await axios.post(`${URL}/orders/${id}/completeTransaction`, {
//           servitorId: selectedOrder.Servitor?.Id,
//           userId: selectedOrder.User?.Id,
//           serviceId:
//             selectedOrder.serviceId ||
//             selectedOrder.service_id ||
//             selectedOrder.Service?.Id ||
//             null,
//           serviceType,
//           totalAmount: price,
//           rating: Number(editRating) || 0,
//           feedback: editFeedback || "",
//         });
//       } else {
//         // PATCH simple status -> Pending
//         await axios.patch(`${URL}/admin/orders/${id}/status`, {
//           serviceType,
//           status: "Pending",
//         });
//       }

//       setShowEdit(false);
//       setSelectedOrder(null);
//       await fetchOrders();
//       alert("Order updated successfully.");
//     } catch (e) {
//       console.error(e);
//       alert(
//         e?.response?.data?.message ||
//           e?.response?.data?.error ||
//           "Failed to update order"
//       );
//     } finally {
//       setSavingEdit(false);
//     }
//   };

  
//   return (
//     <Container fluid className="adminServitorOrders-container">
//       <Card className="adminServitorOrders-card">
//         <Card.Body>
//           <Card.Header className="adminServitorOrders-header">
//             <h4 className="adminServitorOrders-title">Servitor Accepted Orders</h4>
//           </Card.Header>

//           {/* Filters */}
//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Order Number, User ID or Mobile Number"
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                   className="adminServitorOrders-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="statusFilter">
//                 <Form.Select
//                   value={filterStatus}
//                   onChange={(e) => {
//                     setFilterStatus(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                   className="adminServitorOrders-filter-select"
//                 >
//                   <option value="All">All Statuses</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="In-Progress">In-Progress</option>
//                   <option value="Completed">Completed</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* Service filter + sort controls */}
//           <div className="adminServitorOrders-filter-container" style={{gap:8, display:"flex", flexWrap:"wrap", alignItems:"center"}}>
//             {[
//               "All",
//               "Electrician",
//               "Home Cleaning",
//               "Plumber",
//               "Gas Chula",
//               "AC Service",
//               "Filter",
//               "Tutor Service",
//             ].map((type) => (
//               <Button
//                 key={type}
//                 variant={filterType === type ? "primary" : "outline-primary"}
//                 className="adminServitorOrders-filter-btn"
//                 onClick={() => {
//                   setFilterType(type);
//                   setCurrentPage(1);
//                 }}
//               >
//                 {type}
//               </Button>
//             ))}

//             <Form.Select
//               style={{ width: 160, marginLeft: "auto" }}
//               value={sortBy}
//               onChange={(e) => {
//                 setSortBy(e.target.value);
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="created_at">Sort by Created</option>
//               <option value="date">Sort by Service Date</option>
//               <option value="price">Sort by Price</option>
//             </Form.Select>
//             <Form.Select
//               style={{ width: 120 }}
//               value={sortDir}
//               onChange={(e) => {
//                 setSortDir(e.target.value);
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="DESC">DESC</option>
//               <option value="ASC">ASC</option>
//             </Form.Select>
//           </div>

//           <Table striped bordered hover responsive className="adminServitorOrders-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Order number</th>
//                 <th>User ID</th>
//                 <th>Mobile</th>
//                 <th>Service</th>
//                 <th>Servitor ID</th>
//                 <th>Status</th>
//                 <th>Price</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {orders.map((order, index) => (
//                 <tr key={order.Id ?? `${order.order_number}-${index}`}>
//                   <td>{index + 1 + (meta.page - 1) * meta.limit}</td>
//                   <td>{order.order_number}</td>
//                   <td>{order.User?.Id}</td>
//                   <td>{order.User?.mobile}</td>
//                   <td>{getServiceName(order)}</td>
//                   <td>{order.Servitor?.Id}</td>
//                   <td>
//                     <Badge className={`adminServitorOrders-badge-${normalizeStatusKey(order.status)}`}>
//                       {order.status}
//                     </Badge>
//                   </td>
//                   <td>{order.price}Tk</td>
//                   <td>{formatDate(order.date)}</td>
//                   <td>{order.time}</td>
//                   <td>
//                     <div className="adminServitorOrders-action-group">
//                       <Button
//                         variant="outline-primary"
//                         size="sm"
//                         className="adminServitorOrders-action-btn"
//                         onClick={() => handleViewDetails(order)}
//                       >
//                         <BsEye size={16} />
//                       </Button>
//                       <Button
//                         variant="outline-edit"
//                         size="sm"
//                         className="adminServitorOrders-action-btn"
//                         onClick={() => handleEditOrder(order)}
//                       >
//                         <FaEdit size={16} />
//                       </Button>
//                       <Button
//                         variant="outline-danger"
//                         size="sm"
//                         className="adminServitorOrders-action-btn"
//                         onClick={() => handleDeleteOrder(order)}
//                       >
//                         <FaTrash size={16} />
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//               {orders.length === 0 && (
//                 <tr>
//                   <td colSpan={11} style={{ textAlign: "center" }}>
//                     No orders found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>

//           {/* Pagination from backend meta */}
//           <Pagination>
//             <Pagination.First
//               onClick={() => setCurrentPage(1)}
//               disabled={meta.page === 1}
//             />
//             <Pagination.Prev
//               onClick={() => setCurrentPage(meta.page - 1)}
//               disabled={meta.page === 1}
//             />
//             {getPageItems(meta.totalPages, meta.page).map((item, idx) => {
//               if (item === "start-ellipsis" || item === "end-ellipsis") {
//                 return <Pagination.Ellipsis key={item + idx} disabled />;
//               }
//               return (
//                 <Pagination.Item
//                   key={item}
//                   active={item === meta.page}
//                   onClick={() => setCurrentPage(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               );
//             })}
//             <Pagination.Next
//               onClick={() => setCurrentPage(meta.page + 1)}
//               disabled={meta.page === meta.totalPages}
//             />
//             <Pagination.Last
//               onClick={() => setCurrentPage(meta.totalPages)}
//               disabled={meta.page === meta.totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div className="adminServitorOrders-modal-backdrop" ref={modalRef}>
//           {renderOrderDetails()}
//         </div>
//       )}

//        {/* =================== EDIT STATUS MODAL =================== */}
//             <Modal
//               show={showEdit}
//               onHide={() => setShowEdit(false)}
//               centered
//               backdrop="static"
//             >
//               <Modal.Header closeButton>
//                 <Modal.Title>Update Order Status</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <Row className="g-3">
//                   <Col md={12}>
//                     <Form.Label>Status</Form.Label>
//                     <Form.Select
//                       value={editStatus}
//                       onChange={(e) => setEditStatus(e.target.value)}
//                     >
//                       <option value="pending">pending</option>
//                       <option value="Completed">Completed</option>
//                     </Form.Select>
//                     <div className="small text-muted mt-1">
//                       Select <strong>Completed</strong> to finish the job, cut servitor commission, add rating & feedback, and award rewards.
//                     </div>
//                   </Col>
      
//                   {editStatus === "Completed" && (
//                     <>
//                       <Col md={12}>
//                         <Form.Label className="mt-2">Rating</Form.Label>
//                         <Form.Range
//                           min={1}
//                           max={5}
//                           step={1}
//                           value={editRating}
//                           onChange={(e) => setEditRating(Number(e.target.value))}
//                         />
//                         <div className="text-center fw-bold">⭐ {editRating} / 5</div>
//                       </Col>
//                       <Col md={12}>
//                         <FloatingLabel label="Feedback (optional)">
//                           <Form.Control
//                             as="textarea"
//                             style={{ height: 120 }}
//                             value={editFeedback}
//                             onChange={(e) => setEditFeedback(e.target.value)}
//                             placeholder="Write feedback for this service…"
//                           />
//                         </FloatingLabel>
//                       </Col>
//                     </>
//                   )}
//                 </Row>
//               </Modal.Body>
//               <Modal.Footer>
//                 <Button variant="light" onClick={() => setShowEdit(false)} disabled={savingEdit}>
//                   Cancel
//                 </Button>
//                 <Button variant="success" onClick={submitEdit} disabled={savingEdit}>
//                   {savingEdit ? "Saving…" : "Save"}
//                 </Button>
//               </Modal.Footer>
//             </Modal>
//             {/* ========================================================= */}

//     </Container>
//   );
// };

// export default ServitorConfirmOrders;





// ***** Upper code is okay, Just update Auth protect (2-Dec-2025) ***** //
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Table,
  Container,
  Card,
  Pagination,
  Badge,
  Button,
  InputGroup,
  Form,
  Row,
  Col,
  Modal,
  FloatingLabel,
} from "react-bootstrap";

import { BsEye } from "react-icons/bs";

import {
  FaTimes,
  FaBolt,
  FaUser,
  FaCheckCircle,
  FaDollarSign,
  FaCalendar,
  FaPlusCircle,
  FaWrench,
  FaCogs,
  FaStar,
  FaUserCircle,
  FaPhone,
  FaIdBadge,
  FaMapMarkerAlt,
  FaClock,
  FaPrint,
  FaDownload,
  FaCheck,
  FaEdit,
  FaTrash,
  FaBroom,
  FaFire,
  FaSnowflake,
  FaFilter as FaFilterIcon,
  FaUserGraduate,
} from "react-icons/fa";
import "./ServitorConfirmOrders.css";
import { formatDate } from "../../dateTimefrontpart";
import { URL } from "../../../config";

const DEFAULT_LIMIT = 10;


// Custom services helper (supports backend parsed customServices OR parses custom_service_json)
const getCustomItems = (order) => {
  if (Array.isArray(order?.customServices)) return order.customServices;

  const raw = order?.custom_service_json;
  if (!raw) return [];

  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};


/* ===========================
   ADMIN AUTH HELPER
   =========================== */
const getAdminHeaders = () => {
  const adminToken = localStorage.getItem("adminToken");
  return adminToken ? { Authorization: `Bearer ${adminToken}` } : {};
};

const normalizeStatusKey = (s) =>
  s ? String(s).toLowerCase().replace(/\s+/g, "-") : "unknown";

const getServiceName = (row) =>
  row?.Service?.services_name ||
  row?.service_name ||
  row?.service ||
  row?.serviceType ||
  "Service";

const toBoolYesNo = (v) => (v ? "Yes" : "No");
const safeNum = (v, fallback = 0) => (v === 0 || v ? v : fallback);

const ServitorConfirmOrders = () => {
  // data
  const [orders, setOrders] = useState([]);
  const [meta, setMeta] = useState({
    page: 1,
    limit: DEFAULT_LIMIT,
    total: 0,
    totalPages: 1,
    sortBy: "created_at",
    sortDir: "DESC",
    serviceType: "All",
    status: "",
    search: "",
  });

  // ui state
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef(null);

  // NEW: edit modal state
  const [showEdit, setShowEdit] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);
  const [editStatus, setEditStatus] = useState("Pending");
  const [editRating, setEditRating] = useState(5);
  const [editFeedback, setEditFeedback] = useState("");

  // filters (controlled -> triggers backend fetch)
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("All");
  const [filterStatus, setFilterStatus] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);

  // sorting controls
  const [sortBy, setSortBy] = useState("created_at"); // 'created_at' | 'date' | 'price'
  const [sortDir, setSortDir] = useState("DESC"); // 'ASC' | 'DESC'

  // fetch from backend with pagination + filters
  const fetchOrders = async () => {
    try {
      const { data } = await axios.get(
        `${URL}/accepted-servitor-orders`,
        {
          params: {
            page: currentPage,
            limit: DEFAULT_LIMIT,
            search: searchTerm,
            status: filterStatus === "All" ? "" : filterStatus,
            serviceType: filterType === "All" ? "" : filterType,
            sortBy,
            sortDir,
          },
          headers: getAdminHeaders(),
        }
      );

      setOrders(Array.isArray(data?.data) ? data.data : []);
      if (data?.meta) {
        setMeta(data.meta);
      } else {
        setMeta((m) => ({
          ...m,
          page: currentPage,
          limit: DEFAULT_LIMIT,
          total: Array.isArray(data) ? data.length : 0,
          totalPages: 1,
          sortBy,
          sortDir,
          serviceType: filterType,
          status: filterStatus === "All" ? "" : filterStatus,
          search: searchTerm,
        }));
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      setOrders([]);
      setMeta((m) => ({ ...m, total: 0, totalPages: 1 }));
    }
  };

  useEffect(() => {
    fetchOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchTerm, filterType, filterStatus, sortBy, sortDir]);

  // modal controls
  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
    document.body.style.overflow = "auto";
  };

  // optional edit/delete hooks
  const handleEditOrder = (order) => {
    setSelectedOrder(order);
    setEditStatus(order.status === "Completed" ? "Completed" : "Pending");
    setEditRating(5);
    setEditFeedback("");
    setShowEdit(true);
  };
  const handleDeleteOrder = (order) =>
    console.log("Deleting order:", order);

  // backdrop/esc close
  useEffect(() => {
    const node = modalRef.current;
    const handleBackdropClick = (e) => {
      if (node && e.target === node) handleCloseModal();
    };
    const handleEscapeKey = (e) => {
      if (e.key === "Escape") handleCloseModal();
    };
    if (node) node.addEventListener("click", handleBackdropClick);
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      if (node) node.removeEventListener("click", handleBackdropClick);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  const handlePrintReceipt = () => window.print();
  const handleDownloadInvoice = () =>
    console.log("Downloading invoice...");

  const getServiceIcon = (type) => {
    switch (type) {
      case "Electrician":
        return <FaBolt />;
      case "Home Cleaning":
        return <FaBroom />;
      case "Plumber":
        return <FaCogs />;
      case "Gas Chula":
        return <FaFire />;
      case "AC Service":
        return <FaSnowflake />;
      case "Filter":
        return <FaFilterIcon />;
      case "Tutor Service":
        return <FaUserGraduate />;
      default:
        return <FaCogs />;
    }
  };

  const buildTimeline = (order) => {
    const steps = [];
    const safeDate = (v) => (v ? new Date(v) : null);

    steps.push({
      key: "placed",
      label: "Order Placed",
      time: safeDate(order.created_at),
      dotClass: "completed",
    });

    if (order.accepted_at) {
      steps.push({
        key: "accepted",
        label: "Order Accepted",
        time: safeDate(order.accepted_at),
        dotClass:
          ["Accepted", "In-Progress", "Completed"].includes(order.status)
            ? "completed"
            : "inactive",
      });
    }

    if (order.in_progress_at) {
      steps.push({
        key: "in_progress",
        label: "Service In Progress",
        time: safeDate(order.in_progress_at),
        dotClass:
          ["In-Progress", "Completed"].includes(order.status)
            ? "in-progress"
            : "inactive",
      });
    }

    if (order.completed_at) {
      steps.push({
        key: "completed",
        label: "Order Completed",
        time: safeDate(order.completed_at),
        dotClass: "arrived",
      });
    }

    const st = String(order.status || "").toLowerCase();
    if (st.includes("cancel")) {
      steps.push({
        key: "cancelled",
        label: `Order ${order.status}`,
        time: safeDate(order.updated_at) || new Date(),
        dotClass: "cancelled",
      });
    }

    return steps.filter((s) => s.time instanceof Date && !isNaN(s.time));
  };

  const getPageItems = (total, current, maxButtons = 7) => {
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, current - siblings);
    let end = Math.min(total - 1, current + siblings);

    if (current <= siblings + 2)
      end = Math.min(total - 1, maxButtons - 1);
    if (current >= total - (siblings + 1))
      start = Math.max(2, total - (maxButtons - 2));

    if (start > 2) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push("end-ellipsis");
    if (total > 1) pages.push(total);
    return pages;
  };

  const renderOrderDetails = () => {
    if (!selectedOrder) return null;
    const type = getServiceName(selectedOrder);
    const icon = getServiceIcon(type);

    // Build service-specific "details"
    let details = {};
    if (type === "Electrician") {
      details = {
        Installation: {
          "New Ceiling Fan Installation":
            selectedOrder.new_ceiling_fan_installation,
          "Ceiling Fan Installation":
            selectedOrder.ceiling_fan_installation,
          "Ceiling Fan Uninstallation":
            selectedOrder.ceiling_fan_uninstallation,
          "Light Installation": selectedOrder.light_installation,
          "Exhaust Fan Installation":
            selectedOrder.exhaust_fan_installation,
          "Doorbell Installation": selectedOrder.doorbell_installation,
          "Switch Setup": selectedOrder.switch_setup,
          "Socket Setup": selectedOrder.socket_setup,
          "Regulator Setup": selectedOrder.regulator_setup,
          "IPS Installation (Existing Line)":
            selectedOrder.ips_installation_existing_line,
          "IPS New Line Installation":
            selectedOrder.ips_new_line_installation,
        },
        Repair: {
          "Fan Coil Repair": selectedOrder.fan_coil_repair,
          "Light Repair": selectedOrder.light_repair,
        },
        Maintenance: {
          "Fan Coil New Winding": selectedOrder.fan_coil_new_winding,
          "Capacitor Setup": selectedOrder.capacitor_setup,
          "Exhaust Fan Cleaning": selectedOrder.exhaust_fan_cleaning,
          "Main Circuit Board Setup":
            selectedOrder.main_circuit_board_setup,
        },
        Additional: {
          "New Wiring Point": selectedOrder.new_wiring_point,
          "Drill Hole Service": selectedOrder.drill_hole_service,
          "Electrical Checkup": selectedOrder.Electrical_checkup
            ? "Yes"
            : "No",
        },
      };
    } else if (type === "Home Cleaning") {
      details = {
        "Room Cleaning": {
          "Bed Cleaning": safeNum(selectedOrder.bed, 0),
          "Bathroom Cleaning": safeNum(selectedOrder.bath, 0),
          "Drawing/Dining Cleaning": safeNum(
            selectedOrder.dra_din,
            0
          ),
          "Balcony Cleaning": safeNum(selectedOrder.balcony, 0),
          "Kitchen Cleaning": safeNum(selectedOrder.kitchen, 0),
          "Satirs & Railing Cleaning": safeNum(
            selectedOrder.stairs_and_railing,
            0
          ),
        },
        "Additional Cleaning": {
          "Window & Grill Cleaning": safeNum(
            selectedOrder.window_grill,
            0
          ),
          "Furniture Cleaning": safeNum(
            selectedOrder.furniture_cleaning,
            0
          ),
          "Cloth Washing": safeNum(selectedOrder.cloth, 0),
          "Dish Washing": safeNum(selectedOrder.dish, 0),
          "Carpet Cleaning": safeNum(
            selectedOrder.carpet_cleaning,
            0
          ),
        },
      };
    } else if (type === "Plumber") {
      details = {
        Installation: {
          "Angle Valve Setup": selectedOrder.angle_valve_setup,
          "Basin Tap (Faucet) Setup": selectedOrder.basin_tap_setup,
          "Magic Pipe (Flexible Drain) Setup":
            selectedOrder.magic_pipe_setup,
          "Basin Waste / Pop-Up Setup":
            selectedOrder.basin_waste_pop_up_setup,
          "New Basin Setup (existing lines)":
            selectedOrder.new_basin_setup_existing_lines,
          "Bathroom Tap Setup":
            selectedOrder.bathroom_tap_bib_cock_setup,
          "Tissue Holder Setup": selectedOrder.tissue_holder_setup,
          "Hand Shower Setup": selectedOrder.hand_shower_setup,
          "Soap Dish Setup": selectedOrder.soap_dish_setup,
          "Bathroom Shelf Setup": selectedOrder.bathroom_shelf_setup,
          "Looking Glass/Mirror Setup": selectedOrder.mirror_setup,
          "Towel Hanger / Ring Setup":
            selectedOrder.towel_hanger_setup,
          "Shower Head + Hose Setup":
            selectedOrder.shower_head_setup,
          "Concealed Stopcock Valve Setup":
            selectedOrder.concealed_stopcock_setup,
          "Floor Drain Net Setup":
            selectedOrder.floor_drain_net_setup,
          "Toilet Seat Complete Installation":
            selectedOrder.toilet_seat_complete_installation,
          "High Commode Installation (existing lines)":
            selectedOrder.high_commode_installation_existing_lines,
          "Kitchen Sink Setup (existing lines)":
            selectedOrder.kitchen_sink_setup_existing_lines,
          "Geyser Installation": selectedOrder.geyser_installation,
          "Washing Machine Point Setup (existing Line)":
            selectedOrder.washing_machine_point_setup,
        },
        Repair: {
          "Toilet Seat Cover Replacement":
            selectedOrder.toilet_seat_cover_replacement,
          "Fill Valve Replacement (High Commode)":
            selectedOrder.fill_valve_replacement,
          "Blockage Clearing — High Commode":
            selectedOrder.blockage_clearing_high_commode,
          "Blockage Clearing — Low Commode":
            selectedOrder.blockage_clearing_low_commode,
        },
        Maintenance: {
          "Bathroom Drain Line Cleaning (per bathroom)":
            selectedOrder.bathroom_drain_line_cleaning,
          "Sink Blockage Cleaning":
            selectedOrder.sink_blockage_cleaning,
        },
        Additional: {
          "Plumbing Checkup / Diagnosis": selectedOrder.issue_checkup
            ? "Yes"
            : "No",
        },
      };
    } else if (type === "Gas Chula") {
      details = {
        Installation: {
          "Cylinder Type":
            selectedOrder.chulaCylinderType ||
            selectedOrder.cylinderType ||
            "-",
          "New Chula Setup": safeNum(
            selectedOrder.NewchulaSetup ??
              selectedOrder.newChulaSetup,
            0
          ),
          "Chula Setup": safeNum(selectedOrder.chulaSetup, 0),
          "Burner Setup": safeNum(selectedOrder.burnerSetup, 0),
        },
        Maintenance: {
          "Burner Cleaning": safeNum(
            selectedOrder.burnerCleaning,
            0
          ),
          "Nozzle Replacement": safeNum(
            selectedOrder.nozzleReplacement,
            0
          ),
          "Check Issues": toBoolYesNo(
            selectedOrder.checkIssues
          ),
        },
      };
    } else if (type === "AC Service") {
      const n = (v) =>
        v == null || isNaN(Number(v)) ? 0 : Number(v);
      details = {
        Specifications: {
          "AC Type": selectedOrder.acType || "-",
          "AC Ton": selectedOrder.acTon || "-",
        },
        Installation: {
          "AC Install (Outdoor Unit Inside)":
            n(selectedOrder.installation_outdoor_inside),
          "AC Install (Outdoor Unit Outside)":
            n(selectedOrder.installation_outdoor_outside),
        },
        Uninstallation: {
          "AC Uninstall (Outdoor Unit Inside)":
            n(
              selectedOrder.uninstallation_outdoor_inside
            ),
          "AC Uninstall (Outdoor Unit Outside)":
            n(
              selectedOrder.uninstallation_outdoor_outside
            ),
        },
        Maintenance: {
          "AC Cleaning (Outdoor Unit Inside)":
            n(selectedOrder.cleaning_outdoor_inside),
          "AC Cleaning (Outdoor Unit Outside)":
            n(selectedOrder.cleaning_outdoor_outside),
          "Issue Checkup (units)":
            n(selectedOrder.issue_checkup),
        },
      };
    } else if (type === "Filter") {
      details = {
        Specifications: {
          "Filter Type": selectedOrder.filter_type || "-",
        },
        Additional: {
          "Issue Checkup": toBoolYesNo(selectedOrder.check_up),
        },
        Installation: {
          "New Filter Setup": safeNum(
            selectedOrder.new_filter_setup,
            0
          ),
          "Filter Installation": safeNum(
            selectedOrder.installation_filter,
            0
          ),
          "Filter Uninstallation": safeNum(
            selectedOrder.uninstallation_filter,
            0
          ),
        },
        Maintenance: {
          "Kit Replacement": safeNum(
            selectedOrder.kit_replacement,
            0
          ),
          "Pipe Leak / Replace": safeNum(
            selectedOrder.pipe_leak_or_replace,
            0
          ),
          "Full Servicing": safeNum(
            selectedOrder.full_servicing,
            0
          ),
        },
      };
    } else if (type === "Tutor Service") {
      const clean = (v) =>
        v !== undefined &&
        v !== null &&
        String(v).trim() !== "" &&
        String(v).trim().toLowerCase() !== "any";

      const core = {};
      if (clean(selectedOrder.subject))
        core["Subject"] = selectedOrder.subject;
      if (clean(selectedOrder.classLevel))
        core["Class/Level"] = selectedOrder.classLevel;
      if (clean(selectedOrder.medium))
        core["Medium"] = selectedOrder.medium;

      const schedule = {};
      if (clean(selectedOrder.daysPerWeek))
        schedule["Days per Week"] = `${selectedOrder.daysPerWeek}`;
      if (clean(selectedOrder.hoursPerDay))
        schedule["Hours per Day"] = `${selectedOrder.hoursPerDay}`;
      if (clean(selectedOrder.salary))
        schedule["Salary"] = `৳${selectedOrder.salary}`;

      const prefs = {};
      if (clean(selectedOrder.preferredTutorGender))
        prefs["Preferred Tutor Gender"] =
          selectedOrder.preferredTutorGender;
      if (clean(selectedOrder.priorityInstitution))
        prefs["Priority Institution"] =
          selectedOrder.priorityInstitution;

      details = {};
      if (Object.keys(core).length) details["Tutoring"] = core;
      if (Object.keys(schedule).length)
        details["Schedule & Budget"] = schedule;
      if (Object.keys(prefs).length) details["Preferences"] = prefs;
    }

    // remarks + custom services (after details built, before return)
    const remarkText = String(selectedOrder?.remarks || "").trim();

    const customItems = getCustomItems(selectedOrder).filter((c) => {
      const name = String(c?.name || "").trim();
      const price = Number(c?.price || 0);
      return name && Number.isFinite(price) && price > 0;
    });

    const customTotal = customItems.reduce((sum, c) => sum + Number(c.price || 0), 0);

    return (
      <div className="adminServitorOrders-modal">
        <div className="adminServitorOrders-modal-header">
          <button
            className="adminServitorOrders-modal-close"
            onClick={handleCloseModal}
          >
            <FaTimes size={20} />
          </button>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <div className="adminServitorOrders-service-icon">
              {icon}
            </div>
            <div>
              <h2 className="adminServitorOrders-modal-title">
                Order Details
              </h2>
              <p className="adminServitorOrders-modal-subtitle">
                Order #{selectedOrder.order_number} • {type} Service
              </p>
            </div>
          </div>
        </div>

        <div className="adminServitorOrders-modal-body">
          <div className="adminServitorOrders-summary-cards">
            <div className="adminServitorOrders-summary-card adminServitorOrders-status-card">
              <div>
                <p className="adminServitorOrders-detail-text">
                  Status
                </p>
                <span
                  className={`adminServitorOrders-badge-${normalizeStatusKey(
                    selectedOrder.status
                  )}`}
                >
                  {selectedOrder.status}
                </span>
              </div>
              <FaCheckCircle
                size={24}
                style={{ color: "#22c55e" }}
              />
            </div>
            <div className="adminServitorOrders-summary-card adminServitorOrders-price-card">
              <div>
                <p className="adminServitorOrders-detail-text">
                  Total Amount
                </p>
                <p className="adminServitorOrders-price-value">
                  ৳{selectedOrder.price}
                </p>
              </div>
              <FaDollarSign
                size={24}
                style={{ color: "#2563eb" }}
              />
            </div>
            <div className="adminServitorOrders-summary-card adminServitorOrders-date-card">
              <div>
                <p className="adminServitorOrders-detail-text">
                  Service Date
                </p>
                <p className="adminServitorOrders-date-value">
                  {formatDate(selectedOrder.date)}
                </p>
                <p className="adminServitorOrders-time-value">
                  {selectedOrder.time}
                </p>
              </div>
              <FaCalendar
                size={24}
                style={{ color: "#7c3aed" }}
              />
            </div>
          </div>

          <div className="adminServitorOrders-detail-card">
            <h3 className="adminServitorOrders-detail-title">
              <FaUser
                style={{
                  marginRight: "8px",
                  color: "#10b981",
                }}
              />
              Customer Information
            </h3>
            <div className="adminServitorOrders-customer-grid">
              <div>
                <div className="adminServitorOrders-customer-info">
                  <FaUserCircle className="adminServitorOrders-customer-icon" />
                  <div>
                    <p className="adminServitorOrders-detail-text">
                      Customer Name
                    </p>
                    <p className="adminServitorOrders-detail-value">
                      {selectedOrder.User?.FirstName}{" "}
                      {selectedOrder.User?.LastName}
                    </p>
                  </div>
                </div>
                <div className="adminServitorOrders-customer-info">
                  <FaPhone className="adminServitorOrders-customer-icon" />
                  <div>
                    <p className="adminServitorOrders-detail-text">
                      Mobile Number
                    </p>
                    <p className="adminServitorOrders-detail-value">
                      {selectedOrder.User?.mobile}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div className="adminServitorOrders-customer-info">
                  <FaIdBadge className="adminServitorOrders-customer-icon" />
                  <div>
                    <p className="adminServitorOrders-detail-text">
                      User ID
                    </p>
                    <p className="adminServitorOrders-detail-value">
                      {selectedOrder.User?.Id}
                    </p>
                  </div>
                </div>
                <div className="adminServitorOrders-customer-info">
                  <FaMapMarkerAlt className="adminServitorOrders-customer-icon" />
                  <div>
                    <p className="adminServitorOrders-detail-text">
                      Service Location
                    </p>
                    <p className="adminServitorOrders-detail-value">
                      {[
                        selectedOrder.City,
                        selectedOrder.Area,
                        selectedOrder.Address,
                      ]
                        .filter(Boolean)
                        .join(" - ")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="adminServitorOrders-detail-card">
            <h3 className="adminServitorOrders-detail-title">
              {getServiceName(selectedOrder)} Service Details
            </h3>
            <div className="adminServitorOrders-service-grid">
              {Object.entries(details).map(
                ([category, items]) => (
                  <div
                    key={category}
                    className="adminServitorOrders-service-category"
                  >
                    <h4 className="adminServitorOrders-category-title">
                      {category === "Installation" && (
                        <FaPlusCircle
                          style={{
                            marginRight: "8px",
                            color: "#22c55e",
                          }}
                        />
                      )}
                      {category === "Repair" && (
                        <FaWrench
                          style={{
                            marginRight: "8px",
                            color: "#f59e0b",
                          }}
                        />
                      )}
                      {category === "Maintenance" && (
                        <FaCogs
                          style={{
                            marginRight: "8px",
                            color: "#3b82f6",
                          }}
                        />
                      )}
                      {category === "Additional" && (
                        <FaStar
                          style={{
                            marginRight: "8px",
                            color: "#7c3aed",
                          }}
                        />
                      )}
                      {category === "Room Cleaning" && (
                        <FaBroom
                          style={{
                            marginRight: "8px",
                            color: "#10b981",
                          }}
                        />
                      )}
                      {category === "Additional Cleaning" && (
                        <FaStar
                          style={{
                            marginRight: "8px",
                            color: "#7c3aed",
                          }}
                        />
                      )}
                      {category === "Specifications" && (
                        <FaSnowflake
                          style={{
                            marginRight: "8px",
                            color: "#7c3aed",
                          }}
                        />
                      )}
                      {category === "Tutoring" && (
                        <FaUserGraduate
                          style={{
                            marginRight: "8px",
                            color: "#2563eb",
                          }}
                        />
                      )}
                      {category === "Schedule & Budget" && (
                        <FaCalendar
                          style={{
                            marginRight: "8px",
                            color: "#7c3aed",
                          }}
                        />
                      )}
                      {category === "Preferences" && (
                        <FaStar
                          style={{
                            marginRight: "8px",
                            color: "#f59e0b",
                          }}
                        />
                      )}
                      {category}
                    </h4>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      {Object.entries(items).map(
                        ([key, value]) => {
                          const isOff =
                            value === "No" ||
                            value === 0 ||
                            value === "-" ||
                            value === null;
                          return (
                            <div
                              key={key}
                              className={`adminServitorOrders-service-item ${
                                isOff ? "inactive" : ""
                              }`}
                            >
                              <span
                                className={`adminServitorOrders-service-name ${
                                  isOff ? "inactive" : ""
                                }`}
                              >
                                {key}
                              </span>
                              <span
                                className={`adminServitorOrders-service-value${
                                  isOff ? "-inactive" : ""
                                }`}
                              >
                                {value}
                              </span>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>

          {customItems.length > 0 && (
            <div className="adminServitorOrders-detail-card">
              <h3 className="adminServitorOrders-detail-title">
                <FaStar style={{ marginRight: 8, color: "#f59e0b" }} />
                Custom Services
              </h3>

              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {customItems.map((c, idx) => (
                  <div key={idx} className="adminServitorOrders-service-item">
                    <span className="adminServitorOrders-service-name">
                      {idx + 1}. {String(c.name).trim()}
                    </span>
                    <span className="adminServitorOrders-service-value">
                      ৳{Number(c.price).toLocaleString("en-BD")}
                    </span>
                  </div>
                ))}

                <div style={{ marginTop: 10, borderTop: "1px dashed #cbd5e1", paddingTop: 10 }}>
                  <div className="adminServitorOrders-service-item">
                    <span className="adminServitorOrders-service-name" style={{ fontWeight: 700 }}>
                      Custom Total
                    </span>
                    <span className="adminServitorOrders-service-value" style={{ fontWeight: 700 }}>
                      ৳{customTotal.toLocaleString("en-BD")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}


          {remarkText && (
            <div className="adminServitorOrders-detail-card">
              <h3 className="adminServitorOrders-detail-title">
                <FaEdit style={{ marginRight: 8, color: "#10b981" }} />
                Remarks / Notes
              </h3>

              <div
                className="adminServitorOrders-detail-value"
                style={{
                  whiteSpace: "pre-wrap",
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: 10,
                  padding: 12,
                  lineHeight: 1.5,
                }}
              >
                {remarkText}
              </div>
            </div>
          )}



          <div className="adminServitorOrders-detail-card">
            <h3 className="adminServitorOrders-detail-title">
              <FaClock
                style={{
                  marginRight: "8px",
                  color: "#10b981",
                }}
              />
              Order Timeline
            </h3>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              {buildTimeline(selectedOrder).map((step) => (
                <div
                  key={step.key}
                  className="adminServitorOrders-timeline-item"
                >
                  {step.key === "cancelled" ? (
                    <FaTimes
                      size={16}
                      className="adminServitorOrders-timeline-cancel-icon"
                    />
                  ) : (
                    <div
                      className={`adminServitorOrders-timeline-dot ${step.dotClass}`}
                    ></div>
                  )}
                  <div className="adminServitorOrders-timeline-content">
                    <h4>{step.label}</h4>
                    <p>
                      {new Date(step.time).toLocaleString()}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {String(selectedOrder.status || "")
            .toLowerCase()
            .includes("cancel") &&
            selectedOrder.cancellation_feedback && (
              <div className="adminServitorOrders-detail-card">
                <h3 className="adminServitorOrders-detail-title">
                  <FaTimes
                    style={{
                      marginRight: "8px",
                      color: "#ef4444",
                    }}
                  />
                  Cancellation Details
                </h3>
                <p className="adminServitorOrders-detail-value">
                  {selectedOrder.cancellation_feedback}
                </p>
              </div>
            )}
        </div>

        <div className="adminServitorOrders-modal-footer">
          <div className="adminServitorOrders-footer-buttons">
            <button
              className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-print"
              onClick={handlePrintReceipt}
            >
              <FaPrint />
              Print Receipt
            </button>
            <button
              className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-download"
              onClick={handleDownloadInvoice}
            >
              <FaDownload />
              Download Invoice
            </button>
            <button
              className="adminServitorOrders-footer-btn adminServitorOrders-footer-btn-close"
              onClick={handleCloseModal}
            >
              <FaCheck />
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  // for pilot project manually can update NEW: submit edit (Complete or Pending)
  const submitEdit = async () => {
    if (!selectedOrder) return;
    try {
      setSavingEdit(true);

      const id = selectedOrder.Id;
      const serviceType = getServiceName(selectedOrder);
      const price = Number(selectedOrder.price) || 0;

      if (editStatus === "Completed") {
        // POST to completeTransaction API
        await axios.post(
          `${URL}/orders/${id}/completeTransaction`,
          {
            servitorId: selectedOrder.Servitor?.Id,
            userId: selectedOrder.User?.Id,
            serviceId:
              selectedOrder.serviceId ||
              selectedOrder.service_id ||
              selectedOrder.Service?.Id ||
              null,
            serviceType,
            totalAmount: price,
            rating: Number(editRating) || 0,
            feedback: editFeedback || "",
          },
          {
            headers: getAdminHeaders(),
          }
        );
      } else {
        // PATCH simple status -> Pending
        await axios.patch(
          `${URL}/admin/orders/${id}/status`,
          {
            serviceType,
            status: "Pending",
          },
          {
            headers: getAdminHeaders(),
          }
        );
      }

      setShowEdit(false);
      setSelectedOrder(null);
      await fetchOrders();
      alert("Order updated successfully.");
    } catch (e) {
      console.error(e);
      alert(
        e?.response?.data?.message ||
          e?.response?.data?.error ||
          "Failed to update order"
      );
    } finally {
      setSavingEdit(false);
    }
  };

  return (
    <Container fluid className="adminServitorOrders-container">
      <Card className="adminServitorOrders-card">
        <Card.Body>
          <Card.Header className="adminServitorOrders-header">
            <h4 className="adminServitorOrders-title">
              Servitor Accepted Orders
            </h4>
          </Card.Header>

          {/* Filters */}
          <Row className="mb-3">
            <Col md={8}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search by Order Number, User ID or Mobile Number"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="adminServitorOrders-search"
                />
              </InputGroup>
            </Col>
            <Col md={4}>
              <Form.Group controlId="statusFilter">
                <Form.Select
                  value={filterStatus}
                  onChange={(e) => {
                    setFilterStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="adminServitorOrders-filter-select"
                >
                  <option value="All">All Statuses</option>
                  <option value="Accepted">Accepted</option>
                  <option value="In-Progress">In-Progress</option>
                  <option value="Completed">Completed</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* Service filter + sort controls */}
          <div
            className="adminServitorOrders-filter-container"
            style={{
              gap: 8,
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            {[
              "All",
              "Electrician",
              "Home Cleaning",
              "Plumber",
              "Gas Chula",
              "AC Service",
              "Filter",
              "Tutor Service",
            ].map((type) => (
              <Button
                key={type}
                variant={
                  filterType === type
                    ? "primary"
                    : "outline-primary"
                }
                className="adminServitorOrders-filter-btn"
                onClick={() => {
                  setFilterType(type);
                  setCurrentPage(1);
                }}
              >
                {type}
              </Button>
            ))}

            <Form.Select
              style={{ width: 160, marginLeft: "auto" }}
              value={sortBy}
              onChange={(e) => {
                setSortBy(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="created_at">
                Sort by Created
              </option>
              <option value="date">Sort by Service Date</option>
              <option value="price">Sort by Price</option>
            </Form.Select>
            <Form.Select
              style={{ width: 120 }}
              value={sortDir}
              onChange={(e) => {
                setSortDir(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="DESC">DESC</option>
              <option value="ASC">ASC</option>
            </Form.Select>
          </div>

          <Table
            striped
            bordered
            hover
            responsive
            className="adminServitorOrders-table"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Order number</th>
                <th>User ID</th>
                <th>Mobile</th>
                <th>Service</th>
                <th>Servitor ID</th>
                <th>Status</th>
                <th>Price</th>
                <th>Date</th>
                <th>Time</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr
                  key={
                    order.Id ??
                    `${order.order_number}-${index}`
                  }
                >
                  <td>
                    {index + 1 + (meta.page - 1) * meta.limit}
                  </td>
                  <td>{order.order_number}</td>
                  <td>{order.User?.Id}</td>
                  <td>{order.User?.mobile}</td>
                  <td>{getServiceName(order)}</td>
                  <td>{order.Servitor?.Id}</td>
                  <td>
                    <Badge
                      className={`adminServitorOrders-badge-${normalizeStatusKey(
                        order.status
                      )}`}
                    >
                      {order.status}
                    </Badge>
                  </td>
                  <td>{order.price}Tk</td>
                  <td>{formatDate(order.date)}</td>
                  <td>{order.time}</td>
                  <td>
                    <div className="adminServitorOrders-action-group">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="adminServitorOrders-action-btn"
                        onClick={() =>
                          handleViewDetails(order)
                        }
                      >
                        <BsEye size={16} />
                      </Button>
                      <Button
                        variant="outline-edit"
                        size="sm"
                        className="adminServitorOrders-action-btn"
                        onClick={() =>
                          handleEditOrder(order)
                        }
                      >
                        <FaEdit size={16} />
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        className="adminServitorOrders-action-btn"
                        onClick={() =>
                          handleDeleteOrder(order)
                        }
                      >
                        <FaTrash size={16} />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
              {orders.length === 0 && (
                <tr>
                  <td
                    colSpan={11}
                    style={{ textAlign: "center" }}
                  >
                    No orders found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination from backend meta */}
          <Pagination>
            <Pagination.First
              onClick={() => setCurrentPage(1)}
              disabled={meta.page === 1}
            />
            <Pagination.Prev
              onClick={() => setCurrentPage(meta.page - 1)}
              disabled={meta.page === 1}
            />
            {getPageItems(meta.totalPages, meta.page).map(
              (item, idx) => {
                if (
                  item === "start-ellipsis" ||
                  item === "end-ellipsis"
                ) {
                  return (
                    <Pagination.Ellipsis
                      key={item + idx}
                      disabled
                    />
                  );
                }
                return (
                  <Pagination.Item
                    key={item}
                    active={item === meta.page}
                    onClick={() => setCurrentPage(item)}
                  >
                    {item}
                  </Pagination.Item>
                );
              }
            )}
            <Pagination.Next
              onClick={() => setCurrentPage(meta.page + 1)}
              disabled={meta.page === meta.totalPages}
            />
            <Pagination.Last
              onClick={() => setCurrentPage(meta.totalPages)}
              disabled={meta.page === meta.totalPages}
            />
          </Pagination>
        </Card.Body>
      </Card>

      {showModal && (
        <div
          className="adminServitorOrders-modal-backdrop"
          ref={modalRef}
        >
          {renderOrderDetails()}
        </div>
      )}

      {/* =================== EDIT STATUS MODAL =================== */}
      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Order Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="g-3">
            <Col md={12}>
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={editStatus}
                onChange={(e) =>
                  setEditStatus(e.target.value)
                }
              >
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
              </Form.Select>
              <div className="small text-muted mt-1">
                Select <strong>Completed</strong> to finish the
                job, cut servitor commission, add rating &
                feedback, and award rewards.
              </div>
            </Col>

            {editStatus === "Completed" && (
              <>
                <Col md={12}>
                  <Form.Label className="mt-2">
                    Rating
                  </Form.Label>
                  <Form.Range
                    min={1}
                    max={5}
                    step={1}
                    value={editRating}
                    onChange={(e) =>
                      setEditRating(Number(e.target.value))
                    }
                  />
                  <div className="text-center fw-bold">
                    ⭐ {editRating} / 5
                  </div>
                </Col>
                <Col md={12}>
                  <FloatingLabel label="Feedback (optional)">
                    <Form.Control
                      as="textarea"
                      style={{ height: 120 }}
                      value={editFeedback}
                      onChange={(e) =>
                        setEditFeedback(e.target.value)
                      }
                      placeholder="Write feedback for this service…"
                    />
                  </FloatingLabel>
                </Col>
              </>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => setShowEdit(false)}
            disabled={savingEdit}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={submitEdit}
            disabled={savingEdit}
          >
            {savingEdit ? "Saving…" : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* ========================================================= */}
    </Container>
  );
};

export default ServitorConfirmOrders;
